import {
    Component,
    OnInit,
    ViewChild,
    Input,
    OnDestroy,
    AfterViewInit,
    ViewContainerRef,
    ChangeDetectorRef,
} from "@angular/core";
import {
    DocumentoPreEditadoFiscal,
    User,
    Message,
    EmpresaMRV,
    Produto,
    RateioDespesas,
    PedidoAssociado,
    ImagemNotaFiscal,
    TipoDocumento,
    Fornecedor,
    AprovadorSLD,
    Responsavel,
    ColetorCustos,
    CabecalhoProtocolo,
    CondicaoPagamento,
} from "src/app/_models";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatAccordion } from "@angular/material/expansion";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTable } from "@angular/material/table";
import { PageChange, PageDirection } from "src/app/_helpers/page-change.model";
import { ProtocoloFiscalService } from "src/app/_services/protocolo-fiscal.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "src/app/app.component";
import {
    CondicaoPagamentoService,
    DocumentoXmlService,
    TipoDocumentoService,
    DocumentoAprovadoService,
    EmpresaMRVService,
    FornecedorService,
    ValidaCfopService,
    AprovadorSLDService,
    UsuariosResponsaveisService,
    ColetorCustosService,
} from "src/app/_services";
import { CentroLogistico } from "src/app/_models/CentroLogistico";
import { ProdutoService } from "src/app/_services/produto.service";
import { DatePipe } from "@angular/common";
import { ConfirmacaoProtocoloComponent } from "src/app/_components/confirmacaoProtocolo/confirmacaoProtocolo.component";
import { ConfirmacaoDuplicidadeFiscalComponent } from "src/app/_components/confirmacaoDuplicidadeFiscal/confirmacaoDuplicidadeFiscal.component";
import {
    TipoProtocoloEnum,
    TipoDocumentoEnum,
    ProtocoloFiscalPageEnum,
    TipoFiscalEnum,
} from "src/app/_common/enums";
import { StatusProtocoloFiscalModalComponent } from "src/app/_components/status-protocolo-fiscal-modal/status-protocolo-fiscal-modal";
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl,
    FormArray,
} from "@angular/forms";
import { UcmService } from "src/app/_services/ucm.service";
import { BehaviorSubject, Observable } from "rxjs";
import { PopupCentroLogisticoComponent } from "src/app/_components/popup-centro-logistico/popup-centro-logistico.component";
import { startWith, map } from "rxjs/operators";
import { DataHoraService } from "src/app/_services/data-hora.service";
import { MaskService } from "src/app/_services/mask.service";
import * as textMask from "vanilla-text-mask/dist/vanillaTextMask.js";
import moment from "moment";
import { PedidoService } from "src/app/_services/pedido.service";
import { FilterData } from "src/app/_models/FilterData";
import { ProdutoModalService } from "src/app/_services/produto-modal.service";
import { PopUpColetoresComponent } from "src/app/_components/popupColetores/popupColetores.component";
import { SelectionModel } from "@angular/cdk/collections";
import { PopupColetorCustosComponent } from "src/app/_components/popup-coletor-custos/popup-coletor-custos.component";
import { CondicaoParcelamento } from "src/app/_models/CondicaoParcelamento";
import { SnackBarService } from "src/app/_services/snackBar.service";
import { StatusLogProtocolo } from "src/app/_models/StatusLogProtocolo";
import { Medicao } from "src/app/_models/Medicao";
import { PopupMessagesNewStyleTestComponent } from "src/app/_components/popup-messages-new-style-test/popup-messages-new-style-test.component";
import { PopupMessagesComponent } from "src/app/_components/popup-messages/popup-messages.component";
import { CNPJAlfa } from "src/app/_helpers/cnpj-alfa.util";
import {
    animate,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";

enum TipoConsultaAprovador {
    Nome = 1,
    Login = 2,
}

enum TipoOperacao {
    Criacao = 1,
    Consulta = 2,
    Edicao = 3,
}

export interface TipoFiscal {
    value: string;
    viewValue: string;
}

@Component({
    selector: "app-protocolo-fiscal",
    templateUrl: "./protocolo-fiscal.component.html",
    styleUrls: ["./protocolo-fiscal.component.css"],
    animations: [
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition(
                "expanded <=> collapsed",
                animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
            ),
        ]),
    ],
    providers: [DatePipe],
})
export class ProtocoloFiscalComponent implements OnInit, OnDestroy, AfterViewInit {
    // Flag para bloquear campo de emissão após confirmação do modal
    // Removido construtor duplicado acima. Mantendo apenas o construtor completo mais abaixo.
    @ViewChild("inputDataEmissao", { read: ViewContainerRef, static: true })
    public inputDataEmissao;
    @ViewChild("inputDataVencimento", { read: ViewContainerRef, static: true })
    public inputDataVencimento;
    @ViewChild(MatTable, { static: true }) table: MatTable<Produto>;
    @ViewChild("produtoPaginator", { static: true })
    produtoPaginator: MatPaginator;
    @ViewChild("rateioPaginator") rateioPaginator: MatPaginator;
    @ViewChild("pedidoPaginator") pedidoPaginator: MatPaginator;
    @ViewChild("medicaoPaginator") medicaoPaginator: MatPaginator;
    @ViewChild("accordion", { static: true }) Accordion: MatAccordion;

    @Input() LstUploadFiles: string[] = [];
    @Input() FormDataUpload = new FormData();

    protocolo: DocumentoPreEditadoFiscal;
    etapaAtual = {} as number;
    page: PageChange;
    currentUser: User;
    messageModel: Message;
    empresaMrv = new EmpresaMRV();
    bloquearBotaoSalvar = false;
    salvarProtocoloTerreno = false;
    loadTipoDocs: boolean;
    fileUploadLenth: boolean;
    permiteAdicionarArquivoSubject = new BehaviorSubject<boolean>(true);
    permiteAdicionarArquivo$ =
        this.permiteAdicionarArquivoSubject.asObservable();
    tipoDocs: TipoDocumento[];
    tipoDocumentoForm: FormGroup;
    pedidosForm: FormGroup;
    protocoloTerceiros = [81, 82];
    protocoloTerceirosStatus = [20, 43];
    dialogRef: any;
    centrosLogisticos: CentroLogistico[];

    expandedElement: Medicao | null;
    botaoExpandirMedicaoTexto: string;
    botaoExpandirMedicaoCor: string;

    rpaUrbanais: TipoDocumento = {
        codTipoDocumento: "81",
        tipoDespesa: "",
        tipoDocumento: "RPA - Urbamais",
        tipoDocumentoSap: "",
        codigoFuncionalidade: 183,
        status: "",
        mensagem: "",
    };

    rpa: TipoDocumento = {
        codTipoDocumento: "82",
        tipoDespesa: "",
        tipoDocumento: "RPA - MRV",
        tipoDocumentoSap: "",
        codigoFuncionalidade: 183,
        status: "",
        mensagem: "",
    };

    permiteIncluirArquivo = {} as boolean;
    desativarUploadFile = false;

    exibeCondicaoPag = false;
    exibeMsgMesCorrente = false;
    loadCNPJs = false;
    centroLogisticoSelecionado: string;
    carregandoCentroLogistico = false;
    optionsCentroLogistico: string[];
    filteredOptionsCentroLogistico: Observable<string[]>;
    frmCentroLogistico = new FormControl();
    frmAprovador = new FormControl();
    frmCondicaoPg = new FormControl();
    frmDataFixaPag = new FormControl();
    carregandoAprovador = false;
    aprovadoresSLD: AprovadorSLD[];
    optionsAprovador = [] as string[];
    filteredOptionsAprovador: Observable<string[]>;
    filteredList1: any;
    responsaveis: Responsavel[];
    loading = false;
    responsavelSelected = {} as Responsavel;
    mask: MaskService;
    fichaForm: FormGroup;
    produtosForm: FormGroup;
    rateioDespesasForm: FormGroup;
    protocoloBloqueadosEdicao = [7, 8, 9, 12, 81, 82];
    maskedInputDataEmissaoController;
    maskedInputDataVencimentoController;
    fornecedor = new Fornecedor();
    parcelado = false;
    tipoOperacao = {} as TipoOperacao;
    itemRateioTodos = {} as Produto;
    usuarioCriacao = {} as Responsavel;

    lstPedidoAssociado = new Array<PedidoAssociado>();
    condicoesPagamentoAVista: CondicaoPagamento[] = [];
    novaDataVencimentoCalculada: Date = null;
    pedidoSendoProcessado: PedidoAssociado = null;
    displayedColumnsPedido = [
        "codigoPedido",
        "tipo",
        "dataLancamento",
        "loginUsuarioLancamento",
        "valorTotal",
        "acoes",
    ];
    dataSourcePedido = new MatTableDataSource<PedidoAssociado>(
        this.lstPedidoAssociado
    );
    numerosPedidos: string;
    tipoFiscalBloqueado = ["10", "30", "40"];

    tipoFiscal: TipoFiscal[] = [
        { value: "20", viewValue: "Normal" },
        { value: "10", viewValue: "Simples Remessa" },
        { value: "30", viewValue: "Bonificação" },
        { value: "40", viewValue: "Brinde" },
    ];

    justificativas = [
        {
            value: "1 - Não sabia o processo correto",
            viewValue: "1 - Não sabia o processo correto",
        },
        {
            value: "2 - Orientações do gestor/coordendor da área",
            viewValue: "2 - Orientações do gestor/coordendor da área",
        },
        {
            value: "3 - Compra emergencial",
            viewValue: "3 - Compra emergencial",
        },
    ];

    statusNovoProtocolo = [
        { value: 0, viewValue: "Indefinido" },
        { value: 1, viewValue: "Aguardando aprovação" },
        { value: 2, viewValue: "Aguardando processamento da imagem" },
        { value: 3, viewValue: "Erro no processamento da Imagem" },
        { value: 4, viewValue: "Reprovado" },
        { value: 5, viewValue: "Erro ao enviar para Central de Notas" },
        { value: 6, viewValue: "Pendente de processamento da fatura" },
        { value: 7, viewValue: "Aguardando Pagamento" },
        { value: 8, viewValue: "Concluído/Pago" },
        { value: 9, viewValue: "Cancelado" },
        { value: 10, viewValue: "Aguardando lançamento da Fatura" },
        { value: 11, viewValue: "Erro no lançamento da Fatura" },
        { value: 12, viewValue: "Aguardando Aprovação Comercial" },
        { value: 99, viewValue: "Todos os meus protocolos pendentes" },
        { value: 100, viewValue: "Todos pendentes" },
    ];

    statusProtocolo = [
        { value: 0, viewValue: "Todos pendentes" },
        { value: 1, viewValue: "Todos não atribuidos" },
        { value: 2, viewValue: "Todos os meus protocolos pendentes" },
        { value: 3, viewValue: "Todos os protocolos" },
        { value: 10, viewValue: "Protocolo sem documento associado" },
        { value: 12, viewValue: "Devolvido por não conformidade" },
        { value: 20, viewValue: "Aguardando documento no UCM" },
        { value: 40, viewValue: "Concluído" },
        { value: 42, viewValue: "Problema no envio de documento para o UCM" },
        { value: 43, viewValue: "Aguardando envio para central de notas" },
        { value: 44, viewValue: "Cancelado" },
        { value: 45, viewValue: "Problema no enviar para central de notas" },
        { value: 46, viewValue: "Erro local ao enviar para o kofax" },
        {
            value: 47,
            viewValue: "Enviado para central de notas sem documento no UCM",
        },
        { value: 50, viewValue: "Aguardando lançamento de pedidos" },
        { value: 51, viewValue: "Aguardando aprovação de pedidos no SLD" },
        { value: 52, viewValue: "Aguardando cadastro de itens de pedido" },
        { value: 54, viewValue: "Protocolo criado" },
        { value: 55, viewValue: "Recusado pelo cockpit" },
        { value: 56, viewValue: "Aguardando revisão" },
        { value: 57, viewValue: "Protocolo colocado na fila para pagamento" },
    ];

    sistemas = [
        { value: 1, viewValue: "MRV Obras" },
        { value: 125, viewValue: "Protocolo Ged" },
        { value: 153, viewValue: "MRV Pag" },
    ];

    pedidoPreexistente = false;
    permiteEditarProdutos = true;
    permiteEditarAliquota = false;
    dataSourceProdutos = new MatTableDataSource<Produto>(new Array<Produto>());
    displayedColumnsProduto: string[] = [
        "item-produto",
        "cnae-produto",
        "idSapProduto-produto",
        "descricao-produto",
        "unidade-produto",
        "quantidade-produto",
        "valorUnitario-produto",
        "valorTotal-produto",
        "aliquotaIPI-produto",
        "ipi-produto",
        "contaContabil-produto",
        "idSapPedidoContrato-produto",
        "acoes-produto",
    ];

    //TODO Samuel
    toleranciaDivergenciaRateio = 10.0 as number;
    possuiPedidoAssociado: boolean;
    dataSourceRateio = new MatTableDataSource<RateioDespesas>(
        new Array<RateioDespesas>()
    );
    produtoSelected = {} as Produto;
    rateioAdicionado = {} as RateioDespesas;
    coletoresCusto: ColetorCustos[];
    verifingColetor = false;
    coletoresCustoError = new Array<ColetorCustos>();
    itemProduto = 0;
    pesColetorCustos: boolean;
    diagramaDeRede = false;
    cabecalhoProtocolo = {} as CabecalhoProtocolo;
    displayedColumnsRateio: string[] = [
        "item",
        "numeroSerial",
        "tipoColetor",
        "coletorCusto",
        "numeroOperacao",
        "descricao",
        "valor",
        "idSapPedidoContrato",
        "select",
    ];

    //Medicões
    arrMedicao: Array<Medicao> = [];

    ordenacaoMedicao: Array<Medicao> = [];
    dataSourceMedicao = new MatTableDataSource<Medicao>(new Array<Medicao>());

    displayedColumnsMedicao: string[] = [
        "checkBox",
        "idMedicaoAssociada",
        "codigoItemPedido",
        "valorTotal-medicao",
        "acoes-medicao",
    ];

    selectionMedicao = new SelectionModel<Medicao>(true, []);

    selection = new SelectionModel<RateioDespesas>(true, []);
    condicoesParcelamento: CondicaoParcelamento[];
    downloadDanfeUCM = {} as boolean;
    danfeValidaSefaz = {} as boolean;

    get fTpDoc() {
        return this.tipoDocumentoForm.controls;
    }
    get fFichaPro() {
        return this.fichaForm.controls;
    }
    get fPedido() {
        return this.pedidosForm.controls;
    }
    get fProduto() {
        return this.produtosForm.controls;
    }
    get fRateio() {
        return this.rateioDespesasForm.controls;
    }

    get produtosArray() {
        return this.produtosForm.get("produtosArray") as FormArray;
    }

    constructor(
        private formBuilder: FormBuilder,
        private apiValidateEmpMRV: EmpresaMRVService,
        private apiValidateFornecedor: FornecedorService,
        private apiValidaCfop: ValidaCfopService,
        private apiAprovadoresSLD: AprovadorSLDService,
        private apiResponsaveis: UsuariosResponsaveisService,
        private apiDataHora: DataHoraService,
        private ucmService: UcmService,
        private apiDocumentoXml: DocumentoXmlService,
        private apiDocumentoAprovado: DocumentoAprovadoService,
        private apiTipoDocService: TipoDocumentoService,
        private protocoloFiscalService: ProtocoloFiscalService,
        private datePipe: DatePipe,
        private apiCondicaoPagamento: CondicaoPagamentoService,
        private route: ActivatedRoute,
        private loadComponent: AppComponent,
        private produtoService: ProdutoService,
        private pedidoService: PedidoService,
        private produtoModalService: ProdutoModalService,
        private coletorCustosService: ColetorCustosService,
        private router: Router,
        private apiProtocoloFiscal: ProtocoloFiscalService,
        private snackBarService: SnackBarService,
        private cdr: ChangeDetectorRef,
        private dialog?: MatDialog
    ) {
        this.protocolo = {} as DocumentoPreEditadoFiscal;
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.mask = new MaskService();
        this.expandedElement = null;
        this.atualizarEstadoBotao();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.maskedInputDataEmissaoController = textMask.maskInput({
                inputElement: this.inputDataEmissao.element.nativeElement,
                mask: this.mask.date.mask,
            });
        });

        setTimeout(() => {
            this.maskedInputDataVencimentoController = textMask.maskInput({
                inputElement: this.inputDataVencimento.element.nativeElement,
                mask: this.mask.date.mask,
            });
        });
    }

    ngOnDestroy() {
        this.maskedInputDataEmissaoController.destroy();
        this.maskedInputDataVencimentoController.destroy();
    }

    async ngOnInit() {
        this.downloadDanfeUCM = false;
        this.danfeValidaSefaz = true;
        this.formBuilderTipoDocumento();
        this.formBuilderFichaProtocolo();
        this.formBuilderPedido();
        this.formBuilderProduto();
        this.formBuilderRateio();
        this.verificaDiagramaDeRede();
        this.carregarCombos();

        this.dataSourcePedido.paginator = this.pedidoPaginator;
        this.dataSourceProdutos.paginator = this.produtoPaginator;
        this.dataSourceRateio.paginator = this.rateioPaginator;
        this.dataSourceMedicao.paginator = this.medicaoPaginator;

        this.protocolo.pedidos = this.protocolo.pedidos || [];
        this.protocolo.produtos = this.protocolo.produtos || [];
        this.protocolo.rateios = this.protocolo.rateios || [];
        this.protocolo.valor = 0;
        this.protocolo.frete = 0;
        this.protocolo.desconto = 0;
        this.protocolo.valorIpi = 0;
        this.protocolo.valorSeguro = 0;
        this.protocolo.valorOutrasDespesas = 0;

        this.loadTipoDocs = true;
        this.fileUploadLenth = false;
        this.permiteAdicionarArquivoSubject.next(true);

        this.protocolo.idProtocolo = 0;
        this.protocolo.idTipoFiscal = "20";
        this.protocolo.naoFiscal = TipoProtocoloEnum.MrvPagFiscal;
        this.protocolo.modoEdicao = !!this.route.snapshot.params["idProtocolo"];
        this.protocolo.loginUsuarioCriacao = this.currentUser.login;
        this.protocolo.parcelado = this.protocolo.parcelado || false;
        this.parcelado = this.parcelado || false;

        this.tipoOperacao = this.route.snapshot.params["idProtocolo"]
            ? TipoOperacao.Consulta
            : TipoOperacao.Criacao;

        if (this.tipoOperacao === TipoOperacao.Consulta) {
            this.desabilitarCamposModoConsulta();
            this.obterDadosProtocolo(this.route.snapshot.params["idProtocolo"]);
        } else {
            this.desativarUploadFile = false;
        }
    }

    expandirContrairTabelaMedicao() {
        this.expandedElement =
            this.expandedElement === null
                ? this.dataSourceMedicao.data[0]
                : null;

        this.atualizarEstadoBotao();
    }

    atualizarEstadoBotao() {
        this.botaoExpandirMedicaoTexto =
            this.expandedElement === null ? "Recolher" : "Expandir";
        this.botaoExpandirMedicaoCor =
            this.expandedElement === null ? "#006B41" : "#fb8c00";
    }

    openAll() {
        this.etapaAtual = ProtocoloFiscalPageEnum.NonExpanded;
        this.onStepChanged(this.etapaAtual);
        this.Accordion.openAll();
    }

    closeAll() {
        this.etapaAtual = ProtocoloFiscalPageEnum.NonExpanded;
        this.onStepChanged(this.etapaAtual);
        this.Accordion.closeAll();
    }

    habilitarModoEdicao() {
        if (
            this.protocolo.loginResponsavel !== this.currentUser.login &&
            !this.currentUser.movimentarProtocoloTerceiros
        ) {
            this.ExibeMensagem(
                "Atenção",
                `O usuário ${this.currentUser.login} não possui permissão para editar o protocolo: ${this.protocolo.idProtocolo}`,
                "warning"
            );
            return;
        }

        if (
            this.protocolo.loginResponsavel === "agenterpa1" &&
            !this.currentUser.movimentarProtocoloAccenture
        ) {
            this.ExibeMensagem(
                "Atenção",
                `O usuário ${this.currentUser.login} não possui permissão para editar o protocolo: ${this.protocolo.idProtocolo}.Apenas usuários da Empresa Accenture podem realizar a edição de protocolos do RPA da Accenture.`,
                "warning"
            );
            return;
        }

        if (
            this.protocolo.idStatusNovo <= 5 ||
            this.protocolo.idStatusNovo === 12
        ) {
            if (
                this.protocolo.idTipoDocumento ===
                    TipoDocumentoEnum.RpaUrbamais ||
                this.protocolo.idTipoDocumento === TipoDocumentoEnum.RPA
            ) {
                this.etapaAtual = ProtocoloFiscalPageEnum.Cabecalho;
                this.desativarUploadFile = false;
            } else {
                this.etapaAtual = ProtocoloFiscalPageEnum.Cabecalho;
                this.habilitarCamposModoEdicao();
            }
            this.closeAll();
            this.tipoOperacao = TipoOperacao.Edicao;
        } else {
            this.ExibeMensagem(
                "Editar Protocolo",
                "O Status atual do protocolo não permite ele ser editado.",
                "warning"
            );
        }
    }

    listarTiposDocumentos(): Promise<boolean> {
        return new Promise((resolve) => {
            this.apiTipoDocService.obterTiposDocumentoFiscal().subscribe(
                (result) => {
                    this.tipoDocs = result?.data ?? ([] as TipoDocumento[]);
                },
                (err) => {
                    console.error(
                        `Ocorreu um erro ao listar os documentos. erro: ${err}`
                    );
                    this.messageModel = new Message(
                        "Erro ao realizar busca",
                        "",
                        `Tente recarregar a tela novamente`,
                        "error"
                    );
                    this.dialog.open(PopupMessagesNewStyleTestComponent, {
                        data: this.messageModel,
                    });
                    this.loadComponent.startLoading(false);
                    resolve(false);
                },
                () => {
                    resolve(true);
                }
            );
        });
    }

    setFile(imagens: ImagemNotaFiscal[]) {
        this.protocolo.imagensNotaFiscal =
            this.protocolo.imagensNotaFiscal || [];

        imagens.forEach((i) => {
            this.LstUploadFiles.push(i.nomeDocumento);
        });
    }

    cabecalhoInnit() {
        this.etapaAtual = ProtocoloFiscalPageEnum.Cabecalho;
        this.onStepChanged(this.etapaAtual);
        this.fileUploadLenth = false;
        this.permiteAdicionarArquivoSubject.next(true);
    }

    bloquearCamposModoEdicao() {
        this.protocolo.modoEdicao = this.protocolo.modoEdicao || false;
        this.protocolo.idStatusNovo = this.protocolo.idStatusNovo || 0;
        if (this.protocolo.modoEdicao) {
            this.fTpDoc["frmTipoDoc"].disable();
            if (
                this.protocoloBloqueadosEdicao.indexOf(
                    this.protocolo.idStatusNovo
                ) !== -1
            ) {
                this.permiteAdicionarArquivoSubject.next(false);
            }
        }
    }

    cabecalhoIsValid() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        if (this.fTpDoc.frmTipoDoc.invalid) {
            return false;
        }

        if (this.LstUploadFiles.length === 0) {
            return false;
        }

        const qtdFiles = this.LstUploadFiles.filter(
            (el) => el.toLowerCase().indexOf("xml") > -1
        );
        if (qtdFiles.length > 0 && this.LstUploadFiles.length === 1) {
            return false;
        }

        return true;
    }

    onChangeTipoDocumento(event: any) {
        event.value = event.value || "";
        const tipoDocSelected = this.tipoDocs.find(
            (t) => t.codTipoDocumento === event.value
        );
        this.protocolo.idTipoDocumento = Number(
            tipoDocSelected.codTipoDocumento
        );
        this.protocolo.descTipoDocumento = tipoDocSelected.tipoDocumento;
        this.protocolo.tipoArquivoXml = null;
        this.armazenarTipoDoc();
    }

    onChangeParcelado() {
        this.protocolo.parcelado = this.protocolo.parcelado || false;
        this.protocolo.dataVencimentoNf = null;
        this.protocolo.descricaoCondicaoPagamento = null;
        this.protocolo.condicaoParcelamento = null;
        this.protocolo.condicaoPagamento = null;
        this.protocolo.parcelado = !this.parcelado;
    }

    onChangeResponsavel() {
        this.protocolo.loginResponsavel = this.responsavelSelected.login;
        this.protocolo.loginUsuarioResponsavel = this.responsavelSelected.login;
        this.protocolo.emailUsuarioResponsavel = this.responsavelSelected.email;
    }

    armazenarTipoDoc() {
        localStorage.setItem(
            "codTipoDocumento",
            this.protocolo.codTipoDocumento
        );

        let itenXml = false;
        this.LstUploadFiles.forEach((element) => {
            if (element.substr(-4).toUpperCase() === ".XML") {
                itenXml = true;
            }
        });

        if (this.protocolo.codTipoDocumento !== "20" && itenXml) {
            this.LstUploadFiles = [];
        }

        this.recebeTipoDocumento(this.protocolo.codTipoDocumento);
    }

    downloadImage(image: any) {
        let img: ImagemNotaFiscal;
        if (this.protocolo.imagensNotaFiscal !== undefined) {
            img = this.protocolo.imagensNotaFiscal.filter(
                (i) => i.nomeDocumento === image
            )[0];
            if (img && img.dadosImagem !== null) {
                this.gerarArquivo(img);
            } else {
                this.ucmService
                    .obterDocumentoPorId(
                        this.protocolo.idProtocolo,
                        img.nomeDocumento
                    )
                    .subscribe(
                        (resultado) => {
                            if (resultado.data.success) {
                                const imgUcm = <ImagemNotaFiscal>resultado.data;
                                this.gerarArquivo(imgUcm);
                            } else {
                                this.messageModel = new Message(
                                    "Download Imagem",
                                    "",
                                    "Imagem não localizada no UCM",
                                    "error"
                                );
                                this.dialog.open(
                                    PopupMessagesNewStyleTestComponent,
                                    { data: this.messageModel }
                                );
                            }
                        },
                        (err) => {
                            console.log(err);
                        }
                    );
            }
        }
    }

    gerarArquivo(img: ImagemNotaFiscal) {
        const nomeDocumento = img.nomeDocumento;
        const extencaoArquivo = img.nomeDocumento.split(".");
        const arrayBytes = this.base64ToArrayBuffer(img.dadosImagem);
        const blob = new Blob([arrayBytes], {
            type: `image/${extencaoArquivo[1]}`,
        });

        const link = document.createElement("a");

        link.href = URL.createObjectURL(blob);

        link.setAttribute("visibility", "hidden");
        link.download = nomeDocumento;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    deleteFile(doc: string) {
        const index = this.LstUploadFiles.findIndex((d) => d === doc);
        this.LstUploadFiles.splice(index, 1);
        this.FormDataUpload.delete(doc);

        this.protocolo.imagensNotaFiscal =
            this.protocolo.imagensNotaFiscal || [];
        const index2 = this.protocolo.imagensNotaFiscal.findIndex(
            (d) => d.nomeDocumento === doc
        );
        this.protocolo.imagensNotaFiscal.splice(index2, 1);

        this.protocolo.tipoArquivoXml = null;
        this.LstUploadFiles.forEach((element) => {
            if (element.substr(-4).toUpperCase() === ".XML") {
                this.protocolo.tipoArquivoXml = "ChaveNf";
            }
        });
    }

    isProtocoloTerceiros() {
        if (
            this.protocolo.modoEdicao &&
            this.protocoloTerceiros.indexOf(this.protocolo.idTipoDocumento) !==
                -1 &&
            this.protocoloTerceirosStatus.indexOf(
                this.protocolo.idStatusProtocolo
            ) !== -1 &&
            this.protocolo.idStatusNovo === 12
        ) {
            return true;
        }

        if (
            this.protocolo.modoEdicao &&
            this.currentUser.login !== this.protocolo.loginResponsavel &&
            !this.currentUser.movimentarProtocoloTerceiros
        ) {
            return true;
        }

        return false;
    }

    aprovarDocumento() {
        const messageModel = new Message(
            "Aprovar Documento",
            "",
            "Tem certeza que deseja proseguir com a aprovação do documento?",
            "confirm"
        );

        this.dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, {
            data: messageModel,
        });
        let confirmarRecebimento;
        this.dialogRef.afterClosed().subscribe((result) => {
            this.loadComponent.startLoading(true);
            confirmarRecebimento = result;

            if (confirmarRecebimento !== null && confirmarRecebimento) {
                this.atualizarDocumentoAprovado();
            } else {
                this.loadComponent.startLoading(false);
            }
        });
    }

    atualizarDocumentoAprovado() {
        let result;
        this.FormDataUpload.append(
            "DocumentoPreEditadoFiscal",
            JSON.stringify(this.protocolo)
        );
        this.protocoloFiscalService
            .AprovarProtocoloFiscal(this.FormDataUpload)
            .subscribe(
                (rtn) => {
                    result = rtn.data;
                },
                (err) => {
                    console.error(err);
                    this.messageModel = new Message(
                        "Erro ao editar",
                        err,
                        "",
                        "error"
                    );
                    this.dialog.open(PopupMessagesNewStyleTestComponent, {
                        data: this.messageModel,
                    });
                },
                () => {
                    if (!result.success) {
                        this.messageModel = new Message(
                            result.message,
                            "",
                            `Detalhes: ${result.data.mensagem} `,
                            "error"
                        );
                        this.dialog.open(PopupMessagesNewStyleTestComponent, {
                            data: this.messageModel,
                        });
                    } else {
                        this.messageModel = new Message(
                            "Item processado com sucesso",
                            "",
                            result.message,
                            "error"
                        );
                        this.dialogRef = this.dialog.open(
                            PopupMessagesNewStyleTestComponent,
                            { data: this.messageModel }
                        );
                        this.dialogRef.afterClosed().subscribe(() => {
                            this.router.navigate(["/home"]);
                        });
                    }
                }
            )
            .add(() => this.loadComponent.startLoading(false));
    }

    onSubmitTipoDoc() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            this.onStepChanged(this.etapaAtual, PageDirection.forward);
            return;
        }

        if (this.LstUploadFiles.length === 0) {
            this.fileUploadLenth = true;
            this.messageModel = new Message(
                "Tipo de Documento",
                "É necessário anexar um documento",
                "",
                "error"
            );
            this.dialogRef = this.dialog.open(
                PopupMessagesNewStyleTestComponent,
                {
                    data: this.messageModel,
                }
            );
            return;
        }

        const qtdFiles = this.LstUploadFiles.filter(
            (el) => el.toLowerCase().indexOf("xml") > -1
        );
        if (
            this.protocolo.codTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais.toString() &&
            qtdFiles.length > 0
        ) {
            this.protocolo.tipoArquivoXml = "ChaveNf";

            if (this.LstUploadFiles.length === 1) {
                this.messageModel = new Message(
                    "Documento NF",
                    "É necessário anexar outro(s) arquivo(s) além da NF.",
                    "",
                    "error"
                );
                this.dialogRef = this.dialog.open(
                    PopupMessagesNewStyleTestComponent,
                    {
                        data: this.messageModel,
                    }
                );
                return;
            }
        } else {
            this.protocolo.idTipoFiscal = "20";
        }

        if (this.cabecalhoIsValid()) {
            this.protocolo.idTipoFiscal = "20";

            if (this.protocolo.cfop)
                this.validarCfop(Number(this.protocolo.cfop));

            this.onStepChanged(this.etapaAtual, PageDirection.forward);
        }
    }

    onPreencherProtocoloComXml() {
        this.processarXML(this.FormDataUpload);
        this.onStepChanged(ProtocoloFiscalPageEnum.FichaProtocolo);
    }

    getErrorMessage() {
        return this.fTpDoc.frmTipoDoc.hasError("required")
            ? "Escolha um Tipo de Documento"
            : "";
    }

    existeArquivoXmlAnexado(): boolean {
        const qtdFiles = this.LstUploadFiles.filter(
            (el) => el.toLowerCase().indexOf("xml") > -1
        );
        if (qtdFiles.length >= 1) {
            return true;
        } else {
            return false;
        }
    }

    async obterDadosProtocolo(id: number) {
        this.loadComponent.startLoading(true);

        this.protocoloFiscalService
            .obterProtocolo(id)
            .subscribe(
                (retorno) => {
                    this.protocolo = retorno.data as DocumentoPreEditadoFiscal;

                    if (
                        this.protocolo.idTipoDocumento ===
                            TipoDocumentoEnum.RpaUrbamais ||
                        this.protocolo.idTipoDocumento === TipoDocumentoEnum.RPA
                    ) {
                        if (
                            this.protocolo.loginResponsavel !==
                                this.currentUser.login &&
                            !this.currentUser.visualizarAprovacaoComercial
                        ) {
                            this.ExibeMensagem(
                                "Atenção",
                                `O usuário ${this.currentUser.login} não possui acesso ao protocolo: ${this.protocolo.idProtocolo}`,
                                "warning"
                            );
                            this.router.navigate(["/home"]);
                        }
                    }

                    if (
                        this.protocolo.loginResponsavel !==
                            this.currentUser.login &&
                        !this.currentUser.visualizarProtocoloTerceiros
                    ) {
                        this.ExibeMensagem(
                            "Atenção",
                            `O usuário ${this.currentUser.login} não possui permissão para visualizar o protocolo: ${this.protocolo.idProtocolo}`,
                            "warning"
                        );
                        this.router.navigate(["/home"]);
                    }
                },
                (err) => {
                    console.log(
                        `Ocorreu um erro ao obter o protocolo. erro: ${err}`
                    );
                    this.loadComponent.startLoading(false);
                },
                () => {
                    this.protocolo.parcelado =
                        this.protocolo.parcelado || false;
                    this.parcelado = this.protocolo.parcelado;
                    this.protocolo.produtos =
                        this.protocolo.produtos || ([] as Produto[]);
                    this.protocolo.pedidos =
                        this.protocolo.pedidos || ([] as PedidoAssociado[]);
                    this.protocolo.rateios =
                        this.protocolo.rateios || ([] as RateioDespesas[]);

                    this.pedidoPreexistente =
                        this.protocolo.pedidos.filter(
                            (x) => x.criacaoAutomaticaMrvPag === false
                        ).length > 0;

                    if (this.pedidoPreexistente) {
                        this.atualizarValorTotalNosRateios(false);
                    }

                    //Ordenação
                    this.protocolo.pedidos = this.ordenarPedidos(
                        this.protocolo.pedidos
                    );

                    this.protocolo.produtos = this.ordenarProdutos(
                        this.protocolo.produtos
                    );

                    this.protocolo.rateios = this.ordenarRateios(
                        this.protocolo.rateios
                    );

                    this.protocolo.idTipoFiscal =
                        this.protocolo.idTipoFiscal || "";

                    if (this.protocolo.idTipoFiscal !== "") {
                        this.protocolo.idTipoFiscal =
                            this.protocolo.idTipoFiscal.toString();
                    }

                    this.protocolo.codTipoDocumento =
                        this.protocolo.idTipoDocumento.toString() || "";
                    this.protocolo.modoEdicao = true;
                    this.protocolo.mesCorrente =
                        this.protocolo.mesCorrente || true;
                    this.protocolo.condicaoPagamento =
                        this.protocolo.condicaoPagamento || null;
                    this.protocolo.loginUsuarioCriacao =
                        this.protocolo.loginUsuarioCriacao ||
                        this.currentUser.login;
                    let dataFixa = new Date(
                        this.verificaDataVencimento(
                            this.protocolo.dataVencimentoNf
                        )
                    );
                    this.protocolo.dataFixaPagamento =
                        moment(dataFixa).format("DD/MM/YYYY");

                    this.protocolo.descricaoStatus =
                        this.protocolo.descricaoStatus || "";

                    // verifica se possui pedido associado
                    this.verificaPedidoAssociado(this.protocolo.pedidos);

                    //Listando Medições
                    this.carregarMedicao(null, this.protocolo.produtos);

                    // verifica se é cpf ou cnpj
                    if (!this.isEmptyOrSpaces(this.protocolo.cpffornecedor)) {
                        this.protocolo.cnpjfornecedor =
                            this.protocolo.cpffornecedor;
                    }

                    this.carregarFornecedor();

                    this.setFile(this.protocolo.imagensNotaFiscal);
                    this.protocolo.valorTotalComDescontos =
                        this.atualizarValorTotalNota();
                    this.preencherDataSourceRateios(this.protocolo.rateios);
                    this.carregarPedido(this.protocolo.pedidos);
                    this.exibirProdutos();

                    if (
                        this.protocolo.idTipoDocumento != 81 &&
                        this.protocolo.idTipoDocumento != 82
                    ) {
                        this.validarCondicaoPagamento();
                    } else {
                        this.protocolo.condicaoPagamento = "0000";
                        this.protocolo.descricaoCondicaoPagamento = "0000";
                    }

                    this.preencherCombosUsuarios();

                    if (
                        this.protocolo.idTipoDocumento ===
                        TipoDocumentoEnum.GuiaISSComplementar
                    ) {
                        this.permiteEditarProdutos = false;
                    }

                    if (this.protocolo.codEmpresa === null) {
                        this.carregarCodEmpresa(
                            this.protocolo.cnpjDestinatario
                        );
                    }
                    this.getAprovadoresSld();
                }
            )
            .add(() => {
                this.loadComponent.startLoading(false);
            });
    }

    isEmptyOrSpaces(str: string) {
        return str === null || /^\s*$/.exec(str) !== null;
    }

    onPedidoAdded() {
        this.preencherListaProdutosPedidos();
        this.preencherDataSourceRateios(this.protocolo.rateios);
    }

    onDeletedItemRateio(item: number) {
        this.protocolo.rateios = this.protocolo.rateios.filter(
            (r) => Number(r.item) !== item
        );
        this.dataSourceRateio = new MatTableDataSource<RateioDespesas>(
            this.protocolo.rateios
        );
        this.dataSourceRateio.paginator = this.rateioPaginator;
        this.validacaoValorTotalRateios("Excluir");
    }

    onStepChanged(event: any, direction?: PageDirection) {
        direction = direction || null;
        if (direction === null) {
            this.page = <PageChange>event;
        } else {
            this.page = new PageChange(event, direction);
        }

        // Validação ao avançar de Pedidos para Produtos sem pedidos associados e com fornecedor de data fixa
        if (
            this.page.direction === PageDirection.forward &&
            this.page.page === ProtocoloFiscalPageEnum.Pedidos &&
            (!this.protocolo.pedidos || this.protocolo.pedidos.length === 0) &&
            this.fornecedor &&
            this.fornecedor.dataFixa === true &&
            this.protocolo.dataVencimentoNf
        ) {
            // Calcular qual seria a data fixa correta
            const dataFixaTimestamp = this.verificaDataVencimento(this.protocolo.dataVencimentoNf);
            const dataFixaCalculada = new Date(dataFixaTimestamp);
            const vencimentoAtual = new Date(this.protocolo.dataVencimentoNf);

            // Comparar se o vencimento é diferente da data fixa calculada
            if (dataFixaCalculada.getTime() !== vencimentoAtual.getTime()) {
                // Mostrar modal informativo e prevenir navegação temporariamente
                this.exibirModalAjusteDataFixaNavegacao(dataFixaCalculada);
                return; // Prevenir navegação até que modal seja fechado
            }
        }

        switch (this.page.direction) {
            case PageDirection.back:
                this.etapaAtual = this.page.page - 1;
                break;
            case PageDirection.forward:
                this.etapaAtual = this.page.page + 1;
                break;
            case PageDirection.keep:
                this.etapaAtual = this.page.page;
                break;
        }
    }

    confirmarAdicaoPedidoPreExistente() {
        const msgConf = this.dialog.open(PopupMessagesNewStyleTestComponent, {
            data: new Message(
                "Atenção",
                "",
                "Deseja incluir algum pedido pré-existente?",
                "confirm"
            ),
        });
        msgConf.afterClosed().subscribe((confirm) => {
            if (!confirm) {
                this.etapaAtual += 2;
            } else {
                this.etapaAtual += 1;
            }
        });
    }

    atualizarProtocolo(formDataUpload: FormData) {
        this.protocoloFiscalService
            .atualizarProtocolo(formDataUpload)
            .subscribe(
                (rtn) => {
                    const temp = rtn;
                    if (
                        temp?.data != null &&
                        (temp.data.success === false || temp.success === false)
                    ) {
                        this.ExibeMensagem(
                            "Edição de Protocolos",
                            "Erro ao editar o protocolo. " + temp.data.message,
                            "warning"
                        );
                    } else {
                        this.ExibeMensagem(
                            "Edição de Protocolos",
                            temp.data.message,
                            "warning"
                        );
                        this.router.navigate(["/home"]);
                    }
                },
                (err) => {
                    console.error(err);
                }
            )
            .add(() => {
                this.bloquearBotaoSalvar = false;
                this.loadComponent.startLoading(false);
            });
    }

    criarProtocolo(protocolo: FormData) {
        this.protocoloFiscalService
            .salvarProtocolo(protocolo)
            .subscribe(
                (rtn) => {
                    const temp = rtn;
                    let _msg = "";
                    if (temp?.data?.data) {
                        temp.data.data.mensagem = temp.data.data.mensagem || "";
                        temp.data.data.message = temp.data.data.message || "";
                        _msg =
                            temp.data.data.mensagem || temp.data.data.message;
                    } else {
                        temp.data.message = temp.data.message || "";
                        _msg = temp.data.message;
                    }
                    if (
                        temp?.data != null &&
                        (temp.data.success === false || temp.success === false)
                    ) {
                        let msgError = _msg.split("\r\n").join("<br>");
                        this.ExibeMensagem(
                            "Cadastro de Protocolos",
                            "Erro ao cadastrar o protocolo. " + msgError,
                            "warning"
                        );
                    } else {
                        let mensagem = "";
                        // Validação erro dominio
                        temp.errors = temp.errors || [];
                        if (temp.errors.length > 0) {
                            temp.errors.map((error: string) => {
                                mensagem += error + "<br>";
                            });
                            console.log("Erro");
                            console.log(JSON.stringify(mensagem));
                            this.ExibeMensagem(
                                "Cadastro de Protocolos",
                                mensagem,
                                "warning"
                            );
                        } else {
                            console.log(JSON.stringify(temp.data.message));
                            this.ExibeMensagem(
                                "Cadastro de Protocolos",
                                temp.data.message,
                                "success"
                            );
                            this.router.navigate(["/home"]);
                        }
                    }
                },
                (err) => {
                    console.error(JSON.stringify(err));
                }
            )
            .add(() => {
                this.bloquearBotaoSalvar = false;
                this.loadComponent.startLoading(false);
            });
    }

    onDataSaving() {
        this.protocolo.produtos.map((element) => {
            element.quantidade = Number(
                element.quantidadeFormated.replace(",", ".")
            );
        });
        this.etapaAtual = ProtocoloFiscalPageEnum.NonExpanded;
        this.protocolo.loginUsuarioCriacao =
            this.protocolo.loginUsuarioCriacao || this.currentUser.login;
        this.protocolo.loginResponsavel =
            this.protocolo.loginResponsavel || this.currentUser.login;
        this.protocolo.loginUsuarioUltAlteracao = this.currentUser.login;

        //TODO Entender esse trecho do código
        if (this.protocolo.rateios.findIndex((x) => x.item === 0) > 0) {
            this.protocolo.rateios.forEach((rateio, index) => {
                rateio.item = null;
            });
        }

        // Remove formatação do CNPJ antes de enviar (preserva letras do CNPJ Alfa)
        if (this.protocolo.cnpjDestinatario) {
            this.protocolo.cnpjDestinatario = CNPJAlfa.removeMascaraCNPJ(this.protocolo.cnpjDestinatario);
        }

        this.FormDataUpload.delete("DocumentoPreEditadoFiscal");
        this.FormDataUpload.append(
            "DocumentoPreEditadoFiscal",
            JSON.stringify(this.protocolo)
        );
        if (this.protocolo.modoEdicao) {
            this.atualizarProtocolo(this.FormDataUpload);
        } else {
            this.criarProtocolo(this.FormDataUpload);
        }
    }

    clearFieldsRelated() {
        this.empresaMrv = new EmpresaMRV();
        this.protocolo.nomeEmpresa = "";
        this.protocolo.centroLogistico = "";

        if (!this.protocolo.centroLogistico) {
            this.centrosLogisticos = new Array<CentroLogistico>();
        }

        // Limpar também os campos do fornecedor quando a empresa for removida
        this.clearFieldsRelatedFornecedor();
        this.protocolo.cnpjfornecedor = "";

        // Limpar data de vencimento quando empresa mudar
        this.protocolo.dataVencimentoNf = null;
    }

    clearFieldsRelatedFornecedor() {
        this.fornecedor = new Fornecedor();
        this.protocolo.nomeFornecedor = "";
        this.protocolo.dataVencimentoNf = null;
        this.protocolo.idSapFornecedor = "";
    }

    padLeft(text: string, padChar: string, size: number): string {
        return (String(padChar).repeat(size) + text).substr(size * -1, size);
    }

    ExibeMensagem(title: string, message: string, status: string = null) {
        this.messageModel = new Message(title, "", `${message}`, status);
        return this.dialog.open(PopupMessagesNewStyleTestComponent, {
            data: this.messageModel,
        });
    }

    recebeTipoDocumento(tipoDocumento: string) {
        if (tipoDocumento === "70") {
            let produtos = [] as Array<Produto>;

            this.loadComponent.startLoading(true);
            this.produtoService
                .buscarProdutoIssComplementar()
                .subscribe(
                    (data) => {
                        produtos = data.data.result;
                    },
                    (err) => {
                        console.error(err);
                        this.messageModel = new Message(
                            "Erro ao buscar um produto para ISS Complementar",
                            "",
                            "Tente recarregar a tela novamente",
                            "error"
                        );
                        this.dialog.open(PopupMessagesNewStyleTestComponent, {
                            data: this.messageModel,
                        });
                    },
                    () => {
                        produtos.map((x, index) => {
                            x.quantidade = 1;
                            index++;
                            x.item = index.toString();
                        });
                        this.protocolo.produtos = produtos;
                        this.exibirProdutos();
                        this.permiteEditarProdutos = false;
                    }
                )
                .add(() => {
                    this.loadComponent.startLoading(false);
                });
        } else {
            this.protocolo.produtos = new Array<Produto>();
            this.exibirProdutos();
            this.permiteEditarProdutos = true;
        }
    }

    cancelarProtocolo() {
        if (
            this.protocolo.idStatusNovo === 6 || // Pendente de Processamento da Fatura
            this.protocolo.idStatusNovo === 7 || // Aguardando Pagamento
            this.protocolo.idStatusNovo === 8 || // Concluído/Pago
            this.protocolo.idStatusNovo === 10
        )
            // Aguardando Lançamento da Fatura
            return this.ExibeMensagem(
                "Cancelar Protocolo",
                "O Status atual do protocolo não permite ele ser cancelado.",
                "warning"
            );

        if (
            this.tipoOperacao !== TipoOperacao.Criacao &&
            this.protocolo.idStatusNovo !== 8 &&
            this.protocolo.idStatusNovo !== 9
        ) {
            const dialog = this.ExibeMensagem(
                "Cancelar Protocolo",
                "Confirma o cancelamento do protocolo?",
                "confirm"
            );
            dialog.afterClosed().subscribe((confirm) => {
                if (confirm != null && confirm) {
                    this.etapaAtual = ProtocoloFiscalPageEnum.NonExpanded;
                    this.loadComponent.startLoading(true);
                    this.protocoloFiscalService
                        .cancelarProtocolo(this.protocolo.idProtocolo)
                        .subscribe(
                            (retorno) => {
                                if (!retorno.data.success) {
                                    this.ExibeMensagem(
                                        "Cancelar Protocolo",
                                        retorno.data.message,
                                        "warning"
                                    );
                                } else {
                                    this.ExibeMensagem(
                                        "Cancelar Protocolo",
                                        retorno.data.message,
                                        "warning"
                                    );
                                    this.router.navigate(["/home"]);
                                }
                            },
                            (err) => {
                                console.log(err);
                                this.ExibeMensagem(
                                    "Cancelar Protocolo",
                                    "Ocorreu um erro ao tentar efetuar o cancelamento.",
                                    "warning"
                                );
                            }
                        )
                        .add(() => this.loadComponent.startLoading(false));
                }
            });
        }
    }

    habilitarAliquota() {
        this.permiteEditarAliquota = true;
    }

    podeEditarProtocolo() {
        this.protocolo.idStatusNovo = this.protocolo.idStatusNovo || 0;
    }

    groupBy(colecao: RateioDespesas[], propriedade: string) {
        let agrupado: any[];
        agrupado = [];
        colecao.forEach(function (i: { [x: string]: any }) {
            let foiAgrupado = false;
            agrupado.forEach(function (j) {
                if (j.Key === i[propriedade]) {
                    j.Elements.push(i);
                    foiAgrupado = true;
                }
            });
            if (!foiAgrupado) {
                agrupado.push({ Key: i[propriedade], Elements: [i] });
            }
        });
        return agrupado;
    }

    groupByMedicoes(colecao: Medicao[], propriedade: string) {
        let agrupado: any[];
        agrupado = [];
        colecao.forEach(function (i: { [x: string]: any }) {
            let foiAgrupado = false;
            agrupado.forEach(function (j) {
                if (j.Key === i[propriedade]) {
                    j.Elements.push(i);
                    foiAgrupado = true;
                }
            });
            if (!foiAgrupado) {
                agrupado.push({
                    Key: i[propriedade],
                    codigoMedicao: i["codigoMedicao"],
                    codigoItemPedido:
                        i["codigoItemPedido"] + "/" + i["codigoPedido"],
                    valorTotal: i["valorTotal"],
                    aceite: i["aceite"],
                    Elements: [i],
                });
            }
        });
        return agrupado;
    }

    validarProtocolo() {
        this.bloquearBotaoSalvar = true;

        if (this.tipoFiscalEhSimplesRemessa()) {
            this.salvarProtocolo();
        } else {
            if (
                this.fichaProdutoIsValid(true, true) &&
                this.validarRateioPorProduto(this.protocolo.rateios)
            ) {
                let mensagem99Coletores =
                    "O rateio ultrapassou a quantidade de 99 coletores por item.<br />";
                mensagem99Coletores +=
                    "O produto e o rateio serão refeitos automaticamente para gerar o pedido corretamente<br />";
                mensagem99Coletores +=
                    `<br />Clique em <b>Não</b> para revisar os lançamentos alterados ou <b>Sim</b> ` +
                    `para continuar com a criação do protocolo.`;

                const msgMat =
                    `Rateio não permitido. A criação de pedido de compras de materiais é limitada a 99 ` +
                    `coletores por item. Favor ajustar lançamento.`;

                let temMais99 = false;
                let agrupado: any[];
                agrupado = this.groupBy(this.protocolo.rateios, "item");

                for (const grupo of agrupado) {
                    const itemAgrupado: RateioDespesas[] = grupo.Elements;

                    if (itemAgrupado.length <= 99) {
                        continue;
                    } else if (itemAgrupado.length > 99) {
                        if (
                            this.protocolo.produtos.some(
                                (c) => c.tipoItem === "M"
                            )
                        ) {
                            this.ExibeMensagem("ATENÇÃO", msgMat, "warning");
                            this.bloquearBotaoSalvar = false;
                            return;
                        }
                        temMais99 = true;
                        break;
                    }
                }

                if (temMais99) {
                    this.dialog
                        .open(PopupMessagesNewStyleTestComponent, {
                            data: new Message(
                                "ATENÇÃO",
                                "",
                                mensagem99Coletores,
                                "confirm"
                            ),
                        })
                        .afterClosed()
                        .subscribe((confirm) => {
                            if (confirm) {
                                this.salvarProtocolo();
                            }
                        });
                } else {
                    this.salvarProtocolo();
                }
            } else {
                this.bloquearBotaoSalvar = false;
            }
        }
    }

    salvarProtocolo() {
        let temp: any;
        this.ValidacaoProdutosServicosAliquotaVazio();
        const dataNfe = this.datePipe.transform(
            this.protocolo.dataEmissaoNf,
            "yyyy-MM-dd"
        );

        this.loadComponent.startLoading(true);
        this.protocoloFiscalService
            .VerificaProtocoloDuplicidade(
                this.protocolo.idProtocolo,
                dataNfe,
                this.protocolo.cnpjfornecedor,
                this.protocolo.documento
            )
            .subscribe(
                (retorno) => {
                    temp = retorno;
                    this.loadComponent.startLoading(false);
                },
                (err) => {
                    this.loadComponent.startLoading(false);
                    this.ExibeMensagem(
                        "Erro ao salvar",
                        err,
                        "warning"
                    ).afterClosed();
                },
                () => {
                    if (temp.data == null) {
                        if (
                            this.protocolo.dataVencimentoNf != null &&
                            this.protocolo.dataVencimentoNf != undefined
                        ) {
                            this.protocolo.dataVencimentoNf = new Date(
                                this.protocolo.dataVencimentoNf
                            );
                        }
                        this.protocolo.dataEmissaoNf = new Date(
                            this.protocolo.dataEmissaoNf
                        );
                        this.protocolo.naoFiscal =
                            TipoProtocoloEnum.MrvPagFiscal;
                        const dialogRef = this.dialog.open(
                            ConfirmacaoProtocoloComponent,
                            { data: this.protocolo, disableClose: true }
                        );
                        let confirmarRecebimento: boolean;
                        dialogRef.afterClosed().subscribe((result) => {
                            confirmarRecebimento = result;
                            confirmarRecebimento = confirmarRecebimento || false;
                            if (confirmarRecebimento) {
                                // Bloqueia os campos de emissão e vencimento

                                if (this.fichaForm && this.fichaForm.controls["frmDtEmissao"]) {
                                    this.fichaForm.controls["frmDtEmissao"].disable();
                                }
                                if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
                                    this.fichaForm.controls["frmVencimento"].disable();
                                }
                                this.cdr.detectChanges();
                                this.loadComponent.startLoading(true);
                                this.onDataSaving();
                            }
                        });
                    } else if (temp.data.eventoDuplicado === 1) {
                        this.ExibeMensagem(
                            "Duplicidade encontrada",
                            "N° do Documento já cadastrado com o protocolo " +
                                temp.data.idProtocolo +
                                " por " +
                                temp.data.loginUsuarioCriacao +
                                " em " +
                                temp.data.dataHoraCriacaoExibicao +
                                ".",
                            "warning"
                        ).afterClosed();
                    } else if (temp.data.eventoDuplicado === 2) {
                        const dialogRef = this.dialog.open(
                            ConfirmacaoDuplicidadeFiscalComponent,
                            { data: temp.data, disableClose: true }
                        );
                        dialogRef.afterClosed().subscribe((result) => {
                            const dataResult = result;
                            if (dataResult != null && dataResult) {
                                this.onDataSaving();
                            }
                        });
                    }
                }
            )
            .add(() => (this.bloquearBotaoSalvar = false));
    }

    //Valida valores vazios Aliquota IPI
    ValidacaoProdutosServicosAliquotaVazio() {
        this.protocolo.produtos.map((v) => {
            if (v.aliquotaIPI.toString() === "") v.aliquotaIPI = 0;
        });
    }

    processarXML(event: any) {
        let element: any;
        this.loadComponent.startLoading(true);
        this.apiDocumentoXml
            .upload(event)
            .subscribe(
                (rtn) => {
                    element = rtn;
                    if (
                        element?.data != null &&
                        element.data.success === false
                    ) {
                        this.dialog.open(PopupMessagesNewStyleTestComponent, {
                            data: new Message(
                                "Erro",
                                element.data.message,
                                "",
                                "error"
                            ),
                        });
                    }
                },
                (err) => {
                    console.error(err);
                },
                () => {
                    this.preencherProtocoloComXml(element.data);
                }
            )
            .add(() => this.loadComponent.startLoading(false));
    }

    preencherProtocoloComXml(element: any) {
        try {
            this.protocolo.codBarras = element.danfe;
            this.protocolo.danfe = element.danfe;
            this.protocolo.serieNotaFiscal = element.serie;
            this.protocolo.documento = element.nDocumento;
            this.protocolo.dataEmissaoNf = element.dataEmissao as Date;
            this.protocolo.dataVencimentoNf = element.dataVencimento as Date;
            this.protocolo.cnpjDestinatario = element.cnpjEmpresa;
            this.carregarEmpresaTomador();
            this.protocolo.cnpjfornecedor = element.cnpjFornecedor;
            this.carregarFornecedor();
            this.protocolo.valor = element.valor;
            this.protocolo.frete = element.frete;
            this.protocolo.desconto = element.desconto;
            this.protocolo.valorIpi = element.valorTotalIPI;
            this.protocolo.valorSeguro = element.valorSeguro;
            this.protocolo.valorOutrasDespesas = element.outrasDespesas;
            this.protocolo.cfop = element.cfop;
            this.validarCfop(Number(this.protocolo.cfop));
            this.protocolo.geraPagamento = element.geraPagamento as boolean;
            this.validarCondicaoPagamento();

            this.protocolo.idTipoDocumento = Number(
                this.protocolo.codTipoDocumento
            );
            this.protocolo.descTipoDocumento =
                this.protocolo.descTipoDocumento || "";
            this.protocolo.idTipoFiscal =
                this.protocolo.geraPagamento === false ? "10" : "20";
            this.atualizarValorTotalNota();
            this.validarDanfeSefaz(this.protocolo.codBarras);
        } catch {}
    }

    desabilitarBotaoSalvar(): boolean {
        if (
            this.salvarProtocoloTerreno ||
            (!this.protocolo.geraPagamento &&
                this.protocolo.geraPagamento !== undefined)
        ) {
            return false;
        } else if (!this.fichaRateioIsValid() || this.bloquearBotaoSalvar) {
            return true;
        } else {
            return false;
        }
    }

    async carregarCombos() {
        await this.carregarCombosTipoDocumento();
        await this.carregarCombosFichaProtocolo();
    }

    async carregarCombosTipoDocumento() {
        await this.listarTiposDocumentos();
    }

    async carregarCombosFichaProtocolo() {
        await this.getAprovadoresSld();
        this.getResponsaveis();
        this.getCondicoesPagamento();
    }

    desabilitarCamposModoConsulta() {
        this.desabilitarCamposCabecalho();
        this.desabilitarCamposFichaProtocolo();
        this.desabilitarCamposPedidos();
        this.desabilitarCamposProdutos();
        this.desabilitarCamposRateios();
    }

    habilitarCamposModoEdicao() {
        this.habilitarCamposCabecalho();
        this.habilitarCamposFichaProtocolo();
        this.habilitarCamposPedidos();
        this.habilitarCamposProdutos();
        this.habilitarCamposRateio();
    }

    desabilitarCamposCabecalho() {
        this.tipoDocumentoForm.disable();
        this.permiteAdicionarArquivoSubject.next(false);
        this.desativarUploadFile = true;
    }

    desabilitarCamposFichaProtocolo() {
        this.fichaForm.disable();
    }

    desabilitarCamposPedidos() {
        this.pedidosForm.disable();
    }

    desabilitarCamposProdutos() {
        this.produtosForm.disable();
    }

    desabilitarCamposRateios() {
        this.rateioDespesasForm.disable();
    }

    habilitarCamposCabecalho() {
        this.desativarUploadFile = false;
    }

    habilitarCamposFichaProtocolo() {
        this.fichaForm.controls["frmNumDocumento"].enable();
        this.fichaForm.controls["frmDtEmissao"].enable();
        this.fichaForm.controls["frmVencimento"].enable();
        this.fichaForm.controls["frmParcelado"].enable();
        this.fichaForm.controls["frmValorTotalNf"].enable();
        this.fichaForm.controls["frmFrete"].enable();
        this.fichaForm.controls["frmDesconto"].enable();
        this.fichaForm.controls["frmValorTotalIpi"].enable();
        this.fichaForm.controls["frmValorSeguro"].enable();
        this.fichaForm.controls["frmValorDespesas"].enable();
        this.fichaForm.controls["frmDescNota"].enable();
    }

    habilitarCamposPedidos() {
        this.pedidosForm.enable();
    }

    habilitarCamposProdutos() {
        this.produtosForm.enable();
        this.fProduto.justificativa.disable();
    }

    habilitarCamposRateio() {
        this.rateioDespesasForm.enable();
        this.rateioDespesasForm.controls["frmItem"].enable();
    }

    desabilitarExclusaoPedido() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }
        if (
            this.protocolo.idTipoDocumento ===
            TipoDocumentoEnum.GuiaISSComplementar
        ) {
            return true;
        }
        return false;
    }

    desabilitarExclusaoProduto() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }
        if (
            this.tipoOperacao === TipoOperacao.Edicao &&
            this.dataSourceMedicao.data.length != 0
        ) {
            return true;
        }
        if (this.protocolo.idTipoDocumento === 70) {
            return true;
        }

        return false;
    }

    desabilitarExclusaoRateio() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }
        if (this.pedidoPreexistente) {
            return true;
        }
        return false;
    }

    atualizarValorTotalNota() {
        this.protocolo.valor = this.protocolo.valor || 0;
        this.protocolo.frete = this.protocolo.frete || 0;
        this.protocolo.valorIpi = this.protocolo.valorIpi || 0;
        this.protocolo.valorSeguro = this.protocolo.valorSeguro || 0;
        this.protocolo.valorOutrasDespesas =
            this.protocolo.valorOutrasDespesas || 0;
        this.protocolo.desconto = this.protocolo.desconto || 0;

        this.protocolo.valorTotalComDescontos =
            this.protocolo.valor -
            this.protocolo.frete -
            this.protocolo.valorIpi -
            this.protocolo.valorSeguro -
            this.protocolo.valorOutrasDespesas +
            Number(this.protocolo.desconto);

        if (this.protocolo.valorTotalComDescontos < 0) {
            this.protocolo.valorTotalComDescontos = 0;
        }

        if (
            this.protocolo.idTipoDocumento === 20 &&
            this.protocolo.valorIpi > 0
        ) {
            this.habilitarAliquota();
        }
        return this.protocolo.valorTotalComDescontos;
    }

    validarCondicaoPagamento() {
        if (
            this.protocolo.dataEmissaoNf == null ||
            this.protocolo.dataVencimentoNf == null
        ) {
            this.loadComponent.startLoading(false);
            return;
        }

        this.loadComponent.startLoading(true);

        this.apiCondicaoPagamento
            .validarCondicaoPagamento(
                this.protocolo.dataEmissaoNf,
                this.protocolo.dataVencimentoNf
            )
            .subscribe(
                (retorno) => {
                    if (!retorno.success) {
                        this.ExibeMensagem(
                            "Condição de Pagamento",
                            retorno.errors,
                            "warning"
                        );
                        this.protocolo.dataVencimentoNf = null;
                    } else {
                        this.exibeCondicaoPag = true;
                        if (retorno.data.ordenacao !== null) {
                            this.exibeMsgMesCorrente = true;
                            this.protocolo.mesCorrente = true;
                        } else {
                            this.exibeMsgMesCorrente = false;
                            this.protocolo.mesCorrente = false;
                        }
                        this.protocolo.descricaoCondicaoPagamento =
                            retorno.data.codigo + " - " + retorno.data.nome;
                        this.protocolo.condicaoPagamento = retorno.data.codigo;
                    }
                    this.loadComponent.startLoading(false);
                },
                (err) => {
                    this.ExibeMensagem(
                        "Condição de Pagamento",
                        "Ocorreu um erro ao validar a condição de pagamento: " +
                            err,
                        "error"
                    );

                    this.loadComponent.startLoading(false);
                }
            );
    }

    /**
     * Formata CNPJ Alfa em tempo real durante a digitação
     * Aplica máscara XX.XXX.XXX/XXXX-XX para CNPJs numéricos ou alfanuméricos
     */
    formatarCNPJEmpresaInput(event: any) {
        let valor = event.target.value;
        // Remove tudo exceto letras e números
        valor = valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

        // Aplica a máscara progressivamente
        if (valor.length > 2) {
            valor = valor.substring(0, 2) + '.' + valor.substring(2);
        }
        if (valor.length > 6) {
            valor = valor.substring(0, 6) + '.' + valor.substring(6);
        }
        if (valor.length > 10) {
            valor = valor.substring(0, 10) + '/' + valor.substring(10);
        }
        if (valor.length > 15) {
            valor = valor.substring(0, 15) + '-' + valor.substring(15, 17);
        }

        this.protocolo.cnpjDestinatario = valor;
    }



    carregarEmpresaTomador() {
        if (this.protocolo.cnpjDestinatario) {
            this.loadComponent.startLoading(true);

            // Remover máscara e converter para maiúsculas (suporta CNPJ Alfa)
            const cnpjSemMascara = CNPJAlfa.removeMascaraCNPJ(
                this.protocolo.cnpjDestinatario
            );

            // Validar CNPJ (antigo ou alfa)
            if (!CNPJAlfa.isValid(cnpjSemMascara)) {
                this.clearFieldsRelated();
                this.ExibeMensagem(
                    "CNPJ Inválido",
                    "O CNPJ da empresa informado é inválido. Verifique os dígitos verificadores.",
                    "warning"
                );
                this.loadComponent.startLoading(false);
                return;
            }

            // Aplicar máscara formatada de volta para visualização
            this.protocolo.cnpjDestinatario = CNPJAlfa.formatarCNPJ(cnpjSemMascara);

            // Limpar data de vencimento sempre que trocar de empresa
            this.protocolo.dataVencimentoNf = null;

            this.loadCNPJs = true;

            this.apiValidateEmpMRV
                .obterEmpresaFiscal(cnpjSemMascara)
                .subscribe(
                    (data) => {
                        this.empresaMrv = data.data;
                    },
                    (err) => console.error(err),
                    () => {
                        if (this.empresaMrv == null) {
                            this.clearFieldsRelated();
                            this.ExibeMensagem(
                                "Empresa",
                                "Empresa não cadastrada"
                            );
                        } else {
                            this.protocolo.codEmpresa =
                                this.empresaMrv.codigoEmp;
                            this.obterCentroLogisticoPorEmpresa();

                            // Limpar data de vencimento quando trocar de empresa
                            this.protocolo.dataVencimentoNf = null;
                        }

                        this.loadCNPJs = false;
                    }
                )
                .add(() => this.loadComponent.startLoading(false));
        } else {
            this.clearFieldsRelated();
        }
    }

    carregarFornecedor() {
        this.protocolo.cnpjfornecedor = this.protocolo.cnpjfornecedor || "";
        if (this.protocolo.cnpjfornecedor !== "") {
            this.loadComponent.startLoading(true);

            // Remover máscara e converter para maiúsculas (suporta CNPJ Alfa)
            const cnpjSemMascara = CNPJAlfa.removeMascaraCNPJ(
                this.protocolo.cnpjfornecedor
            );

            // Validar CNPJ somente se tiver 14 caracteres (formato CNPJ)
            // Campo aceita CPF (11 dígitos) e código também
            if (cnpjSemMascara.length === 14 && !CNPJAlfa.isValid(cnpjSemMascara)) {
                this.clearFieldsRelatedFornecedor();
                this.ExibeMensagem(
                    "CNPJ Inválido",
                    "O CNPJ do fornecedor é inválido. Verifique os dígitos verificadores.",
                    "warning"
                );
                this.loadComponent.startLoading(false);
                return;
            }

            this.loadCNPJs = true;
            this.apiValidateFornecedor
                .ObterFornecedor(cnpjSemMascara)
                .subscribe(
                    (data) => {
                        if (data.data.status == "E") {
                            this.exibirErro(
                                "Consulta de Fornecedor",
                                data.data.mensagem
                            );
                            this.clearFieldsRelatedFornecedor();
                            return;
                        }

                        this.fornecedor = data.data;
                        this.fornecedor.dataFixa = data.data.dataFixa == "X";
                        this.fornecedor.nomeFornecedor =
                            this.fornecedor.codigoFornecedor +
                            " - " +
                            this.fornecedor.nomeFornecedor;
                        this.protocolo.idSapFornecedor =
                            this.fornecedor.codigoFornecedor;
                        this.protocolo.nomeFornecedor =
                            this.fornecedor.nomeFornecedor;
                    },
                    (err) => {
                        this.exibirErro(
                            "Consulta de Fornecedor",
                            "Ocorreu um erro ao consultar Fornecedor. Tente novamente."
                        );
                        this.clearFieldsRelatedFornecedor();
                    },
                    () => {
                        this.loadCNPJs = false;
                        this.verificaDataFixa(this.fornecedor);
                    }
                )
                .add(() => {
                    this.loadComponent.startLoading(false);
                });
        } else {
            this.clearFieldsRelatedFornecedor();
        }
    }

    exibirErro(titulo: string, mensagem: string) {
        this.dialog.open(PopupMessagesNewStyleTestComponent, {
            data: new Message(titulo, "", mensagem, "warning"),
        });
    }

    verificaDataFixa(fornecedor: Fornecedor) {
    var dataVencimento = (this.validarGrupoDataFixa() && !this.validarLogDataFixa()) ? "29" : "10 ou 29";
    var anoAtual = new Date().getFullYear();
    var anoBissexto = (anoAtual % 4 === 0 && anoAtual % 100 !== 0) || (anoAtual % 400 === 0);
    var diaFevereiro = anoBissexto ? "29" : "28";

    if (
        fornecedor.dataFixa &&
        this.tipoOperacao !== TipoOperacao.Consulta
    ) {
        this.exibeMensagem(
            "Data Fixa",
            `Devido ao fornecedor ser aderente a nova forma de pagamento com data fixa, a data de vencimento será alterada para ${dataVencimento}. Para fevereiro, será ajustada para o dia ${diaFevereiro}.`,
            "warning"
        );

        // Recalcular data fixa de pagamento se já existe data de vencimento
        if (this.protocolo.dataVencimentoNf) {
            this.recalcularDataFixaPagamento(this.protocolo.dataVencimentoNf);
        }
    }
}

    validarCfop(cfop: number) {
        this.loadComponent.startLoading(true);
        let status;
        this.apiProtocoloFiscal.ObterCfop(cfop).subscribe(
            (data) => {
                status = data;
            },
            (err) => this.loadComponent.startLoading(false),
            () => {
                this.protocolo.geraPagamento = null;

                if (status.data == null) {
                    this.protocolo.cfop = "";

                    this.ExibeMensagem("CFOP", "CFOP inválido.", "warning");
                } else {
                    this.protocolo.geraPagamento = status.data as boolean;

                    if (!this.protocolo.geraPagamento) {
                        if (this.protocolo.idTipoFiscal === "20") {
                            this.protocolo.idTipoFiscal = "10";
                            this.ExibeMensagem(
                                "CFOP",
                                "Para o CFOP informado, o Tipo Fiscal deve ser Simples Remessa, Brinde ou Bonificação.",
                                "warning"
                            );
                        }
                    } else if (this.protocolo.idTipoFiscal !== "20") {
                        this.protocolo.idTipoFiscal = "20";

                        this.ExibeMensagem(
                            "CFOP",
                            "Para o CFOP informado, o Tipo Fiscal deve ser Normal.",
                            "warning"
                        );
                    }
                }

                this.loadComponent.startLoading(false);
            }
        );
    }

    mostrarDivBuscaCentroLogistico() {
        if (
            typeof this.protocolo.nomeEmpresa !== "undefined" &&
            typeof this.protocolo.centroLogistico === "undefined"
        ) {
            return true;
        }
        return false;
    }

    obterCentroLogisticoPorEmpresa() {
        this.carregandoCentroLogistico = true;

        this.apiValidateEmpMRV
            .ObterCentroLogistico(
                this.empresaMrv.codigoEmp,
                this.empresaMrv.codFil
            )
            .subscribe((data) => {
                this.centrosLogisticos = data.data;
                this.fichaForm.controls["frmNomeEmpresa"].setValue(
                    this.empresaMrv.descricaoEmp
                );
                this.optionsCentroLogistico = this.centrosLogisticos.map(
                    ({ codigoEDescricao }) => codigoEDescricao
                );
                this.filteredOptionsCentroLogistico =
                    this.frmCentroLogistico.valueChanges.pipe(
                        startWith(""),
                        map((value) => this._filterCentroLogistico(value))
                    );

                // TODO: enviar codigo e descricao
                this.centroLogisticoSelecionado =
                    this.protocolo.centroLogistico;

                this.carregandoCentroLogistico = false;

                this.loadComponent.startLoading(false);

                if (this.tipoOperacao !== TipoOperacao.Consulta) {
                    this.abrePopUpCentrosLogisticos();
                }
            });
    }

    abrePopUpCentrosLogisticos() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;

        dialogConfig.data = {
            centrosLogisticos: this.centrosLogisticos,
        };

        const popUpCentroLogistico = this.dialog.open(
            PopupCentroLogisticoComponent,
            dialogConfig
        );

        popUpCentroLogistico.afterClosed().subscribe((result) => {
            this.protocolo.centroLogistico = result.codigoCentroLogistico;
            this.protocolo.divisao = result.codigoDivisao;
            this.centroLogisticoSelecionado = result.codigoEDescricao;
        });
    }

    getAprovadoresSld(): Promise<boolean> {
        return new Promise((resolve) => {
            this.carregandoAprovador = true;
            this.apiAprovadoresSLD
                .ObterAprovadores()
                .subscribe(
                    (data) => {
                        this.aprovadoresSLD = data.data;
                    },
                    (erro) => {
                        console.log(
                            `Ocorreu um erro ao carregar os aprovadores do SAP. erro: ${erro}`
                        );
                        this.messageModel = new Message(
                            "Erro ao realizar busca",
                            "",
                            `Tente recarregar a tela novamente`,
                            "error"
                        );
                        this.dialog.open(PopupMessagesNewStyleTestComponent, {
                            data: this.messageModel,
                        });
                        resolve(false);
                        this.loadComponent.startLoading(false);
                    },
                    () => {
                        const userString = localStorage.getItem("currentUser");
                        const user = JSON.parse(userString);
                        const loginDoUsuario = user.login.toUpperCase();
                        const filteredAprovadores = this.aprovadoresSLD.filter(
                            (aprovador) =>
                                aprovador.login.toUpperCase() !== loginDoUsuario
                        );
                        this.optionsAprovador = filteredAprovadores.map(
                            ({ nome }) => nome
                        );
                        this.filteredList1 = this.optionsAprovador.slice();
                        this.filteredOptionsAprovador =
                            this.frmAprovador.valueChanges.pipe(
                                startWith(""),
                                map((value) => this._filterAprovador(value))
                            );
                        this.carregandoAprovador = false;
                        resolve(true);
                    }
                )
                .add(() => {
                    this.protocolo.loginAprovador =
                        this.protocolo.loginAprovador || "";
                    if (this.protocolo.loginAprovador !== "") {
                        this.setAprovador(
                            this.protocolo.loginAprovador,
                            TipoConsultaAprovador.Login
                        );
                    }
                });
        });
    }

    setAprovador(valor, tipoConsulta: TipoConsultaAprovador) {
        if (this.aprovadoresSLD.length > 0) {
            let aprovador: AprovadorSLD;
            if (tipoConsulta === TipoConsultaAprovador.Nome) {
                aprovador = this.aprovadoresSLD.find(
                    (c) => c.nome.toLowerCase() === valor.toLowerCase()
                );
            } else {
                aprovador = this.aprovadoresSLD.find(
                    (c) => c.login.toLowerCase() === valor.toLowerCase()
                );
            }
            this.protocolo.nomeAprovador = aprovador.nome;
            this.protocolo.loginAprovador = aprovador.login;
            this.fichaForm.controls["frmAprovador"].setValue(aprovador.nome);
        }
    }

    // O sistema não estava salvando o codEmpresa no banco de dados. - 17/10/2019
    // Esse metodo será utilizado para ajustar essa propriedade na edição.

    carregarCodEmpresa(cnpjDestinatario) {
        if (cnpjDestinatario) {
            const re = /[.\-/]/g;

            cnpjDestinatario = cnpjDestinatario.replace(re, "");

            this.apiValidateEmpMRV
                .obterEmpresaFiscal(cnpjDestinatario)
                .subscribe(
                    (data) => {
                        this.empresaMrv = data.data || null;
                    },
                    (err) => console.error(err)
                )
                .add(() => {
                    if (this.empresaMrv !== null) {
                        this.protocolo.codEmpresa = this.empresaMrv.codigoEmp;
                        this.fichaForm.controls["frmNomeEmpresa"].setValue(
                            this.empresaMrv.descricaoEmp
                        );
                    }
                });
        }
    }

    getResponsaveis() {
        this.apiResponsaveis.getResponsaveisAtivos().subscribe(
            (data) => {
                this.responsaveis = data.data;
            },
            (error) => {
                console.log(
                    `Ocorreu um erro ao obter os responsáveis. erro: ${error}`
                );
            },
            () => {
                this.preencherCombosUsuarios();
            }
        );
    }

    preencherCombosUsuarios() {
        this.usuarioCriacao = {} as Responsavel;
        this.responsaveis = this.responsaveis || [];
        if (this.responsaveis.length > 0) {
            this.protocolo.loginResponsavel =
                this.protocolo.loginResponsavel || this.currentUser.login;
            this.protocolo.loginUsuarioCriacao =
                this.protocolo.loginUsuarioCriacao || this.currentUser.login;
            this.responsavelSelected = this.responsaveis.filter(
                (r) => r.login === this.protocolo.loginResponsavel
            )[0];
            this.usuarioCriacao = this.responsaveis.filter(
                (r) => r.login === this.protocolo.loginUsuarioCriacao
            )[0];
            this.responsaveis = this.responsaveis.filter((p) => p.status);
            this.fichaForm.controls["frmResponsavel"].setValue(
                this.responsavelSelected
            );
            this.fichaForm.controls["frmCriadoPor"].setValue(
                this.usuarioCriacao
            );
            if (this.responsavelSelected) {
                this.protocolo.loginResponsavel =
                    this.protocolo.loginUsuarioResponsavel =
                        this.responsavelSelected.login;
                this.protocolo.emailUsuarioResponsavel =
                    this.responsavelSelected.email;
            }
        }
    }

    async onSubmitFicha() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            if (!this.exibeTelaPedidos()) {
                this.etapaAtual = ProtocoloFiscalPageEnum.Produtos;
                this.onStepChanged(this.etapaAtual);
                return;
            }
            this.onStepChanged(this.etapaAtual, PageDirection.forward);
            return;
        }

        this.loadComponent.startLoading(true);

        if (this.fichaProtocoloIsValid()) {
            if (this.tipoFiscalEhSimplesRemessaBonificacaoBrinde()) {
                this.etapaAtual = ProtocoloFiscalPageEnum.Produtos;
            } else {
                this.etapaAtual = ProtocoloFiscalPageEnum.Pedidos;
            }
            this.onStepChanged(this.etapaAtual);
        } else if (
            !this.ehFabricaDeKits() &&
            (!this.danfeValidaSefaz || !this.protocolo.codBarras) &&
            this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
            this.protocolo.idTipoFiscal === TipoFiscalEnum.Normal.toString() &&
            (!this.protocolo.pedidos || this.protocolo.pedidos.length === 0)
        ) {
            this.messageModel = new Message(
                "Sefaz",
                "",
                `DANFE inválida no SEFAZ`,
                "warning"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
        } else {
            this.messageModel = new Message(
                "Erro na ficha do protocolo",
                "",
                `Verifique um possível erro no preenchimento.`,
                "error"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
        }
        this.loadComponent.startLoading(false);
    }

    fichaProtocoloIsValid() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        this.protocolo.codBarras = this.protocolo.codBarras || "";
        if (
            this.LstUploadFiles.filter(
                (p) => p.toLowerCase().indexOf("xml") !== -1
            ).length === 0 &&
            this.protocolo.codBarras !== "" &&
            !this.downloadDanfeUCM &&
            !this.ehFabricaDeKits()
        ) {
            return false;
        }

        if (
            !this.danfeValidaSefaz &&
            this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
            this.protocolo.idTipoFiscal === TipoFiscalEnum.Normal.toString() &&
            !this.ehFabricaDeKits()
        ) {
            return false;
        }

        if (this.aprovadorIsRequired()) {
            this.protocolo.loginAprovador = this.protocolo.loginAprovador || "";
            if (this.protocolo.loginAprovador === "") {
                return false;
            }
        }

        // Aprovador RPA
        if (
            this.protocolo.idStatusNovo === 12 &&
            (this.protocolo.imagensNotaFiscal.length > 0 ||
                this.LstUploadFiles.length > 0)
        ) {
            return true;
        }

        this.protocolo.dataVencimentoNf =
            this.protocolo.dataVencimentoNf || null;
        this.protocolo.codBarras = this.protocolo.codBarras || null;

        if (
            this.dataVencimentoIsRequired() &&
            this.protocolo.dataVencimentoNf === null
        ) {
            return false;
        }

        if (this.tipoOperacao === TipoOperacao.Edicao) {
            this.protocolo.loginResponsavel =
                this.protocolo.loginResponsavel || null;
            this.protocolo.dataEmissaoNf = this.protocolo.dataEmissaoNf || null;
            this.protocolo.dataVencimentoNf =
                this.protocolo.dataVencimentoNf || null;
            this.protocolo.cfop = this.protocolo.cfop || null;
            return (
                this.protocolo.loginResponsavel != null &&
                this.protocolo.dataEmissaoNf !== null &&
                this.protocolo.dataVencimentoNf !== null &&
                (this.protocolo.cfop !== "" ||
                    this.protocolo.idTipoDocumento !== 20)
            );
        }

        // Se há pedidos associados, os campos desabilitados não devem invalidar
        const temPedidosAssociados = this.protocolo.pedidos && this.protocolo.pedidos.length > 0;

        if (
            this.cabecalhoIsValid() &&
            (temPedidosAssociados || this.fFichaPro.frmCnpjEmpresa.valid) &&
            (temPedidosAssociados || this.fFichaPro.frmCnpjFornecedor.valid) &&
            (temPedidosAssociados || this.fFichaPro.frmNomeEmpresa.valid) &&
            (temPedidosAssociados || this.fFichaPro.frmNomeFornecedor.valid !== null) &&
            this.fFichaPro.frmAprovador.valid &&
            (temPedidosAssociados || this.fFichaPro.frmCentroLogistico.valid) &&
            (temPedidosAssociados || this.fFichaPro.frmDtEmissao.valid) &&
            this.fFichaPro.frmResponsavel.valid &&
            this.fFichaPro.frmDescNota.valid &&
            (temPedidosAssociados || this.fFichaPro.frmNumDocumento.valid) &&
            this.fFichaPro.frmValorTotalNf.valid &&
            this.fFichaPro.frmCodBarras.valid &&
            (this.fFichaPro.frmCfop.valid ||
                this.protocolo.idTipoDocumento !== 20)
        ) {
            return true;
        }
        return false;
    }

    dataVencimentoIsRequired() {
        this.protocolo.parcelado = this.protocolo.parcelado || false;

        if (
            parseInt(this.protocolo.idTipoFiscal) ===
                TipoFiscalEnum.SimplesRemessa ||
            parseInt(this.protocolo.idTipoFiscal) ===
                TipoFiscalEnum.Bonificacao ||
            parseInt(this.protocolo.idTipoFiscal) === TipoFiscalEnum.Brinde ||
            this.parcelado
        ) {
            return false;
        }

        return true;
    }

    validarDanfeSefaz(danfe: string) {
        this.apiDocumentoXml.ValidarDanfeSefaz(danfe).subscribe(
            (result) => {
                //Correção de Integração com o ManifestacaoNfe
                this.danfeValidaSefaz = !(
                    result?.success && !result.data.data.danfeValida
                );
            },
            (err) => {
                this.ExibeMensagem(
                    "SEFAZ",
                    "Ocorreu um erro ao validar a danfe no sefaz " + err,
                    "error"
                );
                console.error(err);
            }
        );
    }

    anexarXmlUcm(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            let temp;

            const chaveNf = this.fichaForm.controls["frmCodBarras"].value;
            if (chaveNf === "") {
                this.dialog.open(PopupMessagesNewStyleTestComponent, {
                    data: new Message(
                        "Atenção",
                        `Para que a busca de NF seja feita os campos 'DANFE - CHAVE DE ACESSO/CÓDIGO'` +
                            `, 'CNPJ/CPF/CÓDIGO DO FORNECEDOR', 'Nº DOCUMENTO' e 'EMISSÃO' devem ser preenchidos.`,
                        "",
                        "error"
                    ),
                });
                resolve(false);
            }

            this.loading = true;
            this.apiDocumentoXml
                .DownloadNFeUCM(chaveNf)
                .subscribe(
                    (rtn) => (temp = rtn),
                    (err) => {
                        console.error(err);
                    },
                    () => {
                        if (temp.data.success === false) {
                            if (temp.data.data?.codigo === "XML_NAO_ENCONTRADO") {
                                this.dialog.open(
                                    PopupMessagesNewStyleTestComponent,
                                    {
                                        data: new Message(
                                            "Não encontramos o XML da Nota Fiscal",
                                            "O XML da Nota Fiscal ainda não foi enviado para o repositório da MRV pelo fornecedor.\n\nO que fazer:\n• Se você tem o arquivo XML da nota, anexe-o junto com a nota no início do cadastro.\n• Se não tiver, peça para o fornecedor enviar o XML para o e-mail: nfe@mrv.com.br\n• Após o envio, aguarde alguns minutos antes de tentar novamente.",
                                            "",
                                            "warning"
                                        ),
                                    }
                                );
                            } else {
                                this.dialog.open(
                                    PopupMessagesNewStyleTestComponent,
                                    {
                                        data: new Message(
                                            "Atenção",
                                            temp.data.message,
                                            "",
                                            "error"
                                        ),
                                    }
                                );
                            }
                            resolve(false);
                        } else {
                            if (temp?.data?.danfe != null) {
                                this.protocolo.serieNotaFiscal =
                                    temp.data.serie;
                                if (
                                    this.protocolo.cnpjDestinatario !==
                                    temp.data.cnpjEmpresa
                                ) {
                                    this.protocolo.cnpjDestinatario =
                                        temp.data.cnpjEmpresa;
                                    this.carregarEmpresaTomador();
                                }
                                if (
                                    this.protocolo.cnpjfornecedor !==
                                    temp.data.cnpjfornecedor
                                ) {
                                    this.protocolo.cnpjfornecedor =
                                        temp.data.cnpjFornecedor;
                                    this.carregarFornecedor();
                                }
                                this.protocolo.valor = temp.data.valor;
                                this.protocolo.frete = temp.data.frete;
                                this.protocolo.desconto = temp.data.desconto;
                                this.protocolo.valorIpi =
                                    temp.data.valorTotalIPI;
                                this.protocolo.valorSeguro =
                                    temp.data.valorSeguro;
                                this.protocolo.valorOutrasDespesas =
                                    temp.data.outrasDespesas;
                                if (this.protocolo.cfop !== temp.data.cfop) {
                                    this.protocolo.cfop = temp.data.cfop;
                                    this.validarCfop(
                                        Number(this.protocolo.cfop)
                                    );
                                }
                                this.protocolo.geraPagamento = temp.data
                                    .geraPagamento as boolean;
                                this.protocolo.dataEmissaoNf = temp.data
                                    .dataEmissao as Date;
                                if (
                                    !this.protocolo.dataVencimentoNf &&
                                    this.protocolo.dataVencimentoNf == null
                                ) {
                                    this.protocolo.dataVencimentoNf = temp.data
                                        .dataVencimento as Date;
                                }
                                this.protocolo.documento = temp.data.nDocumento;
                            }
                            this.protocolo.idTipoDocumento = Number(
                                this.protocolo.codTipoDocumento
                            );
                            this.protocolo.descTipoDocumento =
                                this.protocolo.descTipoDocumento || "";
                            this.protocolo.idTipoFiscal =
                                this.protocolo.geraPagamento === false
                                    ? "10"
                                    : "20";
                            this.atualizarValorTotalNota();
                            resolve(true);
                        }
                    }
                )
                .add(() => (this.loading = false));
        });
    }

    onSelectedCentroLogistico(event: any) {
        const centroLogistico: CentroLogistico = this.centrosLogisticos.find(
            (c) => c.codigoEDescricao === event.option.value
        );
        this.centroLogisticoSelecionado = centroLogistico.codigoEDescricao;
        this.protocolo.centroLogistico = centroLogistico.codigoCentroLogistico;
    }

    verificaDataVencimento(dataSelecionada: any) {
        let dataVencimento: Date = new Date(dataSelecionada);
        let dia = dataVencimento.getDate();
        let mes = dataVencimento.getMonth();
        let ano = dataVencimento.getFullYear();

        if(this.validarGrupoDataFixa() && !this.validarLogDataFixa()){
            // Para fevereiro, verifica se o mês tem 29 dias (ano bissexto)
            if (mes === 1) { // Fevereiro é mês 1 (0-based)
                let ultimoDiaFevereiro = new Date(ano, 2, 0).getDate(); // Último dia de fevereiro
                return dataVencimento.setDate(Math.min(29, ultimoDiaFevereiro));
            }
            return dataVencimento.setDate(29);
        } else if (dia <= 10) {
            return dataVencimento.setDate(10);
        } else if (dia > 10 && dia <= 29){
            // Para fevereiro, verifica se o mês tem 29 dias
            if (mes === 1) { // Fevereiro é mês 1 (0-based)
                let ultimoDiaFevereiro = new Date(ano, 2, 0).getDate(); // Último dia de fevereiro
                return dataVencimento.setDate(Math.min(29, ultimoDiaFevereiro));
            }
            return dataVencimento.setDate(29);
        } else {
            dataVencimento.setDate(10);
            dataVencimento.setMonth(dataVencimento.getMonth() + 1);
            return dataVencimento;
        }
    }

    validarLogDataFixa() {
        const empresasValidas = ["MLOG"];

        return empresasValidas.includes(this.protocolo.codEmpresa);
    }

    validarGrupoDataFixa() {
        const gruposValidos = ["YFFM"];

        return gruposValidos.includes(this.fornecedor.codigoGrupoContaFornecedor);
    }

    validarDataVencimento(event) {
        this.protocolo.parcelado = this.protocolo.parcelado || false;
        let dataSelecionada = event.target.value || null;

        if (this.parcelado || !dataSelecionada) {
            return;
        }

        dataSelecionada = moment(dataSelecionada, "DD/MM/YYYY").toISOString();

        if (this.fornecedor.dataFixa) {
            let dataFixaSelecionada = dataSelecionada;
            dataFixaSelecionada = new Date(
                this.verificaDataVencimento(dataFixaSelecionada)
            );
            this.protocolo.dataFixaPagamento =
                moment(dataFixaSelecionada).format("DD/MM/YYYY");
            this.fichaForm.controls["frmDataFixaPag"].setValue(
                this.protocolo.dataFixaPagamento
            );
        }

        this.protocolo.dataVencimentoNf = new Date(dataSelecionada);
        this.fichaForm.controls["frmVencimento"].setValue(
            this.protocolo.dataVencimentoNf
        );
        this.loadComponent.startLoading(true);
        this.apiDataHora
            .ValidarDataVencimento(
                this.protocolo.dataVencimentoNf,
                this.protocolo.idTipoDocumento
            )
            .subscribe(
                (result) => {
                    if (!result.success) {
                        this.ExibeMensagem(
                            "Data de Vencimento",
                            result.errors,
                            "warning"
                        );
                    }
                    this.loadComponent.startLoading(false);
                },
                (err) => {
                    this.ExibeMensagem(
                        "Data de Vencimento",
                        "Ocorreu um erro ao validar a data de vencimento: " +
                            err,
                        "error"
                    );

                    this.loadComponent.startLoading(false);
                }
            );

        if (
            this.protocolo.dataEmissaoNf !== null &&
            this.protocolo.dataVencimentoNf !== null
        ) {
            this.validarCondicaoPagamento();
        }
    }

    add_years(date: any, years: any) {
        return new Date(date.setFullYear(date.getFullYear() + years));
    }

    validarDataEmissao(event) {
        let dataSelecionada = event.target.value || null;
        this.protocolo.parcelado = this.protocolo.parcelado || false;

        if (!dataSelecionada) {
            return;
        }

        dataSelecionada = moment(dataSelecionada, "DD/MM/YYYY").toISOString();
        this.protocolo.dataEmissaoNf = new Date(dataSelecionada);
        this.fichaForm.controls["frmDtEmissao"].setValue(
            this.protocolo.dataEmissaoNf
        );

        const dataAtual = new Date();

        if (this.protocolo.dataEmissaoNf > dataAtual) {
            this.ExibeMensagem(
                "Data de Emissão",
                "A data de emissão informada é maior que a data atual.",
                "warning"
            );
            this.protocolo.dataEmissaoNf = null;
            this.fichaForm.controls["frmDtEmissao"].setValue(null);
            return;
        }

        if (this.parcelado) {
            this.onSelectedCondicaoParcelamento();
        }

        if (
            this.protocolo.dataEmissaoNf !== null &&
            this.protocolo.dataVencimentoNf !== null
        ) {
            this.validarCondicaoPagamento();
        }
    }

    onSelectedCondicaoParcelamento() {
        this.loadComponent.startLoading(true);
        this.protocolo.condicaoPagamento = this.protocolo.condicaoParcelamento;
        this.apiCondicaoPagamento
            .calcularPrimeiroVencimento(
                this.protocolo.condicaoParcelamento,
                this.protocolo.dataEmissaoNf
            )
            .subscribe(
                (retorno) => {
                    this.protocolo.dataVencimentoNf = retorno.data;
                    this.fichaForm.controls["frmVencimento"].setValue(
                        this.protocolo.dataVencimentoNf
                    );
                },
                (erro) => {
                    this.ExibeMensagem(
                        "Condição de Pagamento",
                        "Ocorreu um erro ao calcular o vencimento: " + erro,
                        "error"
                    );
                }
            )
            .add(() => this.loadComponent.startLoading(false));
    }

    onChangeAprovador(event: any) {
        const nome = event.value || "";
        this.setAprovador(nome, TipoConsultaAprovador.Nome);
    }

    validarTipoFiscal(event: any) {
        if (!this.protocolo.geraPagamento) {
            if (event.value === TipoFiscalEnum.Normal) {
                const msg = this.ExibeMensagem(
                    "CFOP",
                    "Para o CFOP informado, o Tipo Fiscal deve ser Simples Remessa, Brinde ou Bonificação.",
                    "warning"
                );
                msg.afterClosed().subscribe((result) => {
                    this.protocolo.idTipoFiscal = "10";
                });
            }
        } else {
            if (event.value !== TipoFiscalEnum.Normal) {
                const msg = this.ExibeMensagem(
                    "CFOP",
                    "Para o CFOP informado, o Tipo Fiscal deve ser Normal.",
                    "warning"
                );
                msg.afterClosed().subscribe((result) => {
                    this.protocolo.idTipoFiscal = "20";
                });
            }
        }
    }

    fichaProtocoloIsDisabled() {
        return this.cabecalhoIsValid() ? false : true;
    }

    fichaProtocoloInnit() {
        this.LstUploadFiles = this.LstUploadFiles || [];
        if (this.LstUploadFiles.length > 0) {
            const qtdFiles = this.LstUploadFiles.filter(
                (el) => el.toLowerCase().indexOf("xml") > -1
            );
            if (!this.protocolo.modoEdicao && qtdFiles.length > 0) {
                this.protocolo.tipoArquivoXml = "ChaveNf";
                this.onPreencherProtocoloComXml();
            } else {
                this.etapaAtual = ProtocoloFiscalPageEnum.FichaProtocolo;
                this.onStepChanged(this.etapaAtual);
            }
        }
    }

    //Limpar erros dos campos ao sair

    limparErrorsInput(frm: string) {
        this.fichaForm.controls[`${frm}`].markAsPristine();
        this.fichaForm.controls[`${frm}`].markAsUntouched();
    }

    /////////////////////////////////////////////////////////////////

    getErrorCNPJMessage() {
        if (
            this.fFichaPro.frmCnpjEmpresa.hasError("minlength") ||
            this.fFichaPro.frmCnpjFornecedor.hasError("minlength")
        ) {
            return "CNPJ inválido";
        }

        if (
            this.fFichaPro.frmCnpjEmpresa.hasError("required") ||
            this.fFichaPro.frmCnpjFornecedor.hasError("required")
        ) {
            return "CPNJ deve ser preenchido";
        }
    }

    pedidoIsDisabled() {
        return this.fichaProtocoloIsValid() ? false : true;
    }

    pedidoInnit() {
        this.etapaAtual = ProtocoloFiscalPageEnum.Pedidos;
        this.onStepChanged(this.etapaAtual);
    }

    Medicoesinnit() {
        this.etapaAtual = ProtocoloFiscalPageEnum.Medicoes;
        this.onStepChanged(this.etapaAtual);
    }

    onSubmitPedido() {
        if (this.fichaPedidoIsValid()) {
            // Verifica se a criação de pedido será automática (sem pedidos pré-existentes)
            const pedidosPreExistentes = (this.protocolo.pedidos || []).filter(
                (p) => p.criacaoAutomaticaMrvPag === false
            );
            const criarPedidoAutomatico = pedidosPreExistentes.length === 0;

            if (criarPedidoAutomatico && !this.currentUser.criarPedidos) {
                this.ExibeMensagem(
                    "Permissão Negada",
                    "Você não possui permissão para criar pedidos no MRV PAG.Por favor, solicite acesso via Gestão Identidade ou informe um número de pedido criado no SAP.",
                    "warning"
                );
                return;
            }

            this.onStepChanged(this.etapaAtual, PageDirection.forward);
        }
    }

    fichaPedidoIsValid() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        if (
            this.protocolo.codEmpresa === "FKIT" &&
            this.protocolo.pedidos.length === 0
        ) {
            return false;
        }

        return this.fichaProtocoloIsValid() &&
            !this.fPedido.frmlistaPedidos.invalid
            ? true
            : false;
    }

    associarPedidos() {
        this.numerosPedidos = this.numerosPedidos || "";
        if (this.numerosPedidos === "") {
            return;
        }

        const numPed: string[] = this.numerosPedidos.split(",");
        const pedidoInvalido = numPed.filter(
            (pedido) => pedido.trim().length > 10
        );

        if (pedidoInvalido.length > 0) {
            this.ExibeMensagem(
                "Busca de Pedidos",
                "O número do pedido não pode ter mais que 10 números.",
                "warning"
            );

            return;
        }

        this.loadComponent.startLoading(true);
        this.pedidoService
            .buscarParametros(
                numPed,
                this.protocolo.centroLogistico,
                this.protocolo.idSapFornecedor
            )
            .subscribe(
                (result) => {
                    result.errors = result.errors || [];
                    if (result.data && result.data[0].status === "E") {
                        console.log(result.data);
                        this.ExibeMensagem(
                            "Busca de Pedidos",
                            result.data[0].mensagem,
                            "warning"
                        );
                    } else if (
                        result.success === false ||
                        result.errors.length > 0
                    ) {
                        this.ExibeMensagem(
                            "Busca de Pedidos",
                            result.errors[0],
                            "warning"
                        );
                    } else {
                        this.lstPedidoAssociado = result.data;

                        // Validar se precisa ajustar data antes de preencher protocolo
                        this.verificarSeNecessitaAjusteDataVencimento();
                    }
                },
                (err) => {
                    this.ExibeMensagem("Busca de Pedidos", err, "warning");
                    this.loadComponent.startLoading(false);
                }
            );
    }

    /**
     * Verifica se é necessário ajustar a data de vencimento e exibe modal de confirmação.
     * Se o usuário confirmar, prossegue com o ajuste. Se cancelar, limpa os pedidos associados.
     */
    verificarSeNecessitaAjusteDataVencimento() {
        let vaiConsultarParcelada = false;

        // Filtrar apenas pedidos pré-existentes
        const pedidosPreExistentes = this.lstPedidoAssociado.filter(
            (pedido) => pedido.criacaoAutomaticaMrvPag === false
        );

        if (pedidosPreExistentes.length === 0) {
            // Não há pedidos pré-existentes, preencher diretamente sem ajuste
            this.preencherProtocoloComPedidos();

            // Travar campos após associar pedido
            this.travarCamposAposAssociarPedido();

            this.loadComponent.startLoading(false);
            return;
        }

        // Buscar condições de pagamento à vista para verificar
        this.apiCondicaoPagamento
            .ObterCondicoesPagamentoAVista()
            .subscribe(
                (response) => {
                    if (!response.success || !response.data) {
                        // Erro na busca, preencher sem ajuste
                        this.preencherProtocoloComPedidos();

                        // Travar campos após associar pedido mesmo em caso de erro
                        this.travarCamposAposAssociarPedido();
                        return;
                    }

                    this.condicoesPagamentoAVista = response.data;

                    // Verificar se algum pedido tem condição de pagamento diferente do protocolo
                    let precisaAjuste = false;
                    const condicaoDoProtocolo = this.protocolo.condicaoPagamento || this.protocolo.condicaoParcelamento;

                    for (const pedido of pedidosPreExistentes) {
                        if (!pedido.condicaoPagamento) {
                            continue;
                        }

                        const condicaoEncontrada = this.condicoesPagamentoAVista.find(
                            (condicao) => condicao.valor === pedido.condicaoPagamento
                        );

                        if (condicaoEncontrada) {
                            // Comparar código da condição de pagamento
                            const condicaoDiferente = condicaoDoProtocolo && pedido.condicaoPagamento !== condicaoDoProtocolo;

                            if (condicaoDiferente) {
                                precisaAjuste = true;
                                this.pedidoSendoProcessado = pedido;

                                // Calcular data de vencimento com base na data de emissão DO PROTOCOLO e condição do pedido
                                const dias = parseInt(condicaoEncontrada.descricao, 10);
                                if (!isNaN(dias) && this.protocolo.dataEmissaoNf) {
                                    const dataEmissaoProtocolo = moment(this.protocolo.dataEmissaoNf);
                                    this.novaDataVencimentoCalculada = dataEmissaoProtocolo.add(dias, 'days').toDate();
                                }
                                break; // Encontrou diferença, não precisa continuar
                            }
                        } else {
                            // Não encontrou na lista à vista, tentar buscar nas condições gerais (parceladas)
                            vaiConsultarParcelada = true;
                            this.buscarCondicaoPagamentoParcelada(pedido);
                            return; // Sai da função pois a busca é assíncrona
                        }
                    }

                    if (precisaAjuste) {
                        // Exibir modal com a data já calculada
                        this.exibirModalConfirmacaoAjusteData();
                    } else {
                        // Não precisa ajuste, preencher diretamente
                        this.preencherProtocoloComPedidos();

                        // Travar campos após associar pedido mesmo sem ajuste
                        this.travarCamposAposAssociarPedido();
                    }
                },
                (err) => {
                    console.error('Erro ao buscar condições à vista:', err);
                    // Erro na busca, preencher sem ajuste
                    this.preencherProtocoloComPedidos();

                    // Travar campos após associar pedido mesmo em caso de erro
                    this.travarCamposAposAssociarPedido();
                },
                () => {
                    // Só desliga loading se não for consultar condição parcelada
                    if (!vaiConsultarParcelada) {
                        this.loadComponent.startLoading(false);
                    }
                }
            );
    }

    /**
     * Busca a condição de pagamento nas condições gerais (parceladas) quando não encontra à vista
     * Para parceladas: compara a condição de pagamento ao invés da data
     * @param pedido - Pedido com a condição não encontrada
     * @param pedidosPreExistentes - Lista completa de pedidos pré-existentes
     */
    buscarCondicaoPagamentoParcelada(pedido: PedidoAssociado) {
        // Buscar nas condições gerais (inclui parceladas)
        this.apiCondicaoPagamento
            .ObterCondicoesPagamento()
            .subscribe(
                (response) => {
                    if (!response.success || !response.data) {
                        this.preencherProtocoloComPedidos();
                        return;
                    }

                    const condicaoEncontrada = response.data.find(
                        (condicao) => condicao.valor === pedido.condicaoPagamento
                    );

                    if (condicaoEncontrada) {
                        // Ativa flag parcelado e atualiza condição de pagamento do protocolo
                        this.protocolo.parcelado = true;
                        this.parcelado = true;
                        this.protocolo.condicaoPagamento = pedido.condicaoPagamento;
                        this.protocolo.condicaoParcelamento = pedido.condicaoPagamento;
                        this.protocolo.descricaoCondicaoPagamento = condicaoEncontrada.codigo + ' - ' + condicaoEncontrada.nome;

                        // Forçar detecção de mudanças para atualizar o campo select
                        this.cdr.detectChanges();

                        // Para parcelado, calcular vencimento com base na data de emissão do protocolo
                        const dias = parseInt(condicaoEncontrada.descricao, 10);
                        this.pedidoSendoProcessado = pedido;

                        if (!isNaN(dias) && this.protocolo.dataEmissaoNf) {
                            const dataEmissaoProtocolo = moment(this.protocolo.dataEmissaoNf);
                            this.novaDataVencimentoCalculada = dataEmissaoProtocolo.add(dias, 'days').toDate();
                        }
                        this.exibirModalConfirmacaoAjusteData();
                    } else {
                        this.preencherProtocoloComPedidos();

                        // Travar campos após associar pedido
                        this.travarCamposAposAssociarPedido();
                    }
                },
                (err) => {
                    console.error('Erro ao buscar condições de pagamento:', err);
                    this.preencherProtocoloComPedidos();

                    // Travar campos após associar pedido mesmo em caso de erro
                    this.travarCamposAposAssociarPedido();
                },
                () => {
                    this.loadComponent.startLoading(false);
                }
            );
    }

    /**
     * Exibe modal de confirmação para ajuste de data de vencimento
     * Usa a data já calculada em novaDataVencimentoCalculada
     */
    exibirModalConfirmacaoAjusteData() {
        // Se fornecedor tem data fixa, calcula a data fixa para exibir no modal
        let dataParaExibir = this.novaDataVencimentoCalculada;

        if (this.fornecedor && this.fornecedor.dataFixa && this.novaDataVencimentoCalculada) {
            // verificaDataVencimento retorna um timestamp, precisa converter para Date
            const dataFixaTimestamp = this.verificaDataVencimento(this.novaDataVencimentoCalculada);
            dataParaExibir = new Date(dataFixaTimestamp);
        }

        const dataVencimentoFormatada = moment(dataParaExibir).format('DD/MM/YYYY');

        const mensagem = `
            O vencimento será ajustado automaticamente conforme a condição de pagamento do pedido associado.<br><br>
            A data de vencimento será ajustada para <strong>${dataVencimentoFormatada}</strong><br><br>
            <strong>Como é calculado o vencimento:</strong><br>
            • Data de emissão informada no protocolo + condição de pagamento do pedido.<br><br>
            <strong>Fornecedores com datas fixas:</strong><br>
            • Nota Fiscal de Serviços: Vencimento ajustado para os dias 10 ou 29.<br>
            • Nota Fiscal de Materiais: Vencimento ajustado para o dia 29.<br><br>
            Em caso de dúvidas, entre em contato com o Suprimentos pelo e-mail <a href="mailto:coe.suprimentos@mrv.com.br">coe.suprimentos@mrv.com.br</a>.
        `;

        const dialogRef = this.dialog.open(PopupMessagesComponent, {
            width: '600px',
            data: new Message(
                'Confirmação de Ajuste',
                '',
                mensagem,
                'confirm'
            )
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                // Usuário confirmou - ajustar data de vencimento e preencher protocolo

                // Atualizar data de vencimento se foi calculada uma nova
                if (this.novaDataVencimentoCalculada) {
                    this.protocolo.dataVencimentoNf = this.novaDataVencimentoCalculada;
                    if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
                        this.fichaForm.controls["frmVencimento"].setValue(this.novaDataVencimentoCalculada);
                    }

                    // Recalcular data fixa de pagamento se fornecedor tiver data fixa
                    this.recalcularDataFixaPagamento(this.novaDataVencimentoCalculada);
                }

                // Forçar detecção de mudanças
                this.cdr.detectChanges();

                this.validarEAjustarDataVencimentoPorCondicaoPagamento();
                this.preencherProtocoloComPedidos();

                // Travar campos após associar pedido
                this.travarCamposAposAssociarPedido();

                this.loadComponent.startLoading(false);
            } else {
                // Usuário cancelou - limpar pedidos e produtos/rateios para não expandir a aba
                this.loadComponent.startLoading(false);
                this.lstPedidoAssociado = [];
                this.numerosPedidos = '';

                // Limpar produtos e rateios (mas manter valorTotalComDescontos da ficha)
                this.protocolo.produtos = [];
                this.protocolo.rateios = [];
                this.dataSourceProdutos = new MatTableDataSource<Produto>([]);
                this.dataSourceRateio = new MatTableDataSource<RateioDespesas>([]);

                // Limpar variáveis temporárias
                this.novaDataVencimentoCalculada = null;
                this.pedidoSendoProcessado = null;

                // Garantir que a aba de produtos não expanda
                this.pedidoPreexistente = false;
                if (this.etapaAtual === ProtocoloFiscalPageEnum.Produtos) {
                    this.etapaAtual = ProtocoloFiscalPageEnum.Pedidos;
                }

                this.ExibeMensagem(
                    'Associação Cancelada',
                    'Não foi possível fazer a associação do pedido.',
                    'warning'
                );
            }
        });
    }

    /**
     * Exibe modal informativo ao tentar avançar de Pedidos para Produtos
     * quando fornecedor tem data fixa e vencimento precisa ser ajustado
     * @param dataFixaCalculada - Data fixa calculada correta
     */
    exibirModalAjusteDataFixaNavegacao(dataFixaCalculada: Date) {
        const dataFixaFormatada = moment(dataFixaCalculada).format('DD/MM/YYYY');
        const vencimentoAtualFormatado = moment(this.protocolo.dataVencimentoNf).format('DD/MM/YYYY');

        // Determinar qual regra está sendo aplicada baseado no grupo do fornecedor
        const isGrupoYFFM = this.validarGrupoDataFixa(); // Grupo YFFM
        const isEmpresaMLOG = this.validarLogDataFixa(); // Empresa MLOG

        let regraAplicada = '';
        if (isGrupoYFFM && !isEmpresaMLOG) {
            regraAplicada = 'Fornecedor do grupo materiais: vencimento sempre ajustado para o <strong>dia 29</strong> do mês.';
        } else {
            regraAplicada = `
                Fornecedor com data fixa:<br>
                • Vencimento entre dia <strong>1 e 10</strong>: ajustado para o <strong>dia 10</strong><br>
                • Vencimento entre dia <strong>11 e 29</strong>: ajustado para o <strong>dia 29</strong><br>
                • Vencimento após dia <strong>29</strong>: ajustado para o <strong>dia 10 do mês seguinte</strong>
            `;
        }

        const mensagem = `
            <strong>⚠️ Atenção: Ajuste de Data Necessário</strong><br><br>
            O fornecedor selecionado possui <strong>data fixa de pagamento</strong>.<br><br>
            <strong>📅 Data de vencimento informada:</strong> ${vencimentoAtualFormatado}<br>
            <strong>📅 Data que será ajustada:</strong> <span style="color: #ff6b00; font-weight: bold;">${dataFixaFormatada}</span><br><br>
            <strong>📋 Regra Aplicada:</strong><br>
            ${regraAplicada}<br><br>
            <small style="color: #666;">
                <strong>Observação:</strong> Esta regra se aplica a todos os tipos de documentos fiscais
                quando o fornecedor possui configuração de data fixa de pagamento.
            </small>
        `;

        const dialogRef = this.dialog.open(PopupMessagesComponent, {
            width: '650px',
            disableClose: true, // Prevenir fechar clicando fora
            data: new Message(
                'Ajuste de Data Fixa',
                '',
                mensagem,
                'alert' // Modal informativo apenas com botão OK
            )
        });

        dialogRef.afterClosed().subscribe(() => {
            // Ajustar vencimento para a data fixa calculada
            this.protocolo.dataVencimentoNf = dataFixaCalculada;
            if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
                this.fichaForm.controls["frmVencimento"].setValue(dataFixaCalculada);
            }

            // Atualizar data fixa de pagamento
            this.protocolo.dataFixaPagamento = moment(dataFixaCalculada).format('DD/MM/YYYY');
            this.fichaForm.controls["frmDataFixaPag"].setValue(
                this.protocolo.dataFixaPagamento
            );

            // Forçar detecção de mudanças
            this.cdr.detectChanges();

            // Agora permitir a navegação para a próxima página
            this.etapaAtual = ProtocoloFiscalPageEnum.Produtos;
        });
    }

    /**
     * Preenche o protocolo com as informações dos pedidos (produtos, rateios, medições)
     */
    preencherProtocoloComPedidos() {
        if (
            this.lstPedidoAssociado.find(
                (p) => p.tipoPedido === "YPRJ"
            )
        ) {
            this.carregarMedicao(this.lstPedidoAssociado, null);
        }

        if (
            this.protocolo.idTipoDocumento !==
                TipoDocumentoEnum.SomenteServicos &&
            this.dataSourceMedicao.data.length != 0
        ) {
            this.limparMedicoes();
            return this.ExibeMensagem(
                "Busca de Pedidos",
                "O pedido buscado deve ser associado á um protocolo do tipo 'NF Somente de Serviços', por gentileza validar as informações inseridas.",
                "warning"
            );
        }

        this.carregarPedido(this.lstPedidoAssociado);
        this.incluirRateiosProdutos();
    }

    /**
     * Valida e ajusta a data de vencimento baseado na condição de pagamento dos pedidos associados.
     * Regra: Se a condição do pedido for diferente das condições à vista,
     * calcula nova data somando os dias (nome) à data de emissão.
     * Aplica apenas para pedidos pré-existentes (criacaoAutomaticaMrvPag = false)
     * Reutiliza os dados já carregados em condicoesPagamentoAVista para evitar requisição duplicada
     */
    validarEAjustarDataVencimentoPorCondicaoPagamento() {
        // Filtrar apenas pedidos pré-existentes
        const pedidosPreExistentes = this.lstPedidoAssociado.filter(
            (pedido) => pedido.criacaoAutomaticaMrvPag === false
        );

        if (pedidosPreExistentes.length === 0) {
            return; // Não há pedidos pré-existentes, não fazer nada
        }

        // Verificar cada pedido pré-existente usando os dados já carregados
        pedidosPreExistentes.forEach((pedido) => {
            this.processarCondicaoPagamentoPedido(pedido);
        });
    }

    /**
     * Processa a condição de pagamento de um pedido específico
     * @param pedido - Pedido a ser processado
     */
    processarCondicaoPagamentoPedido(pedido: PedidoAssociado) {
        if (!pedido.condicaoPagamento) {
            return; // Se não tem condição, não fazer nada
        }

        // Verificar se a condição do pedido é à vista
        const condicaoEncontrada = this.condicoesPagamentoAVista.find(
            (condicao) => condicao.valor === pedido.condicaoPagamento
        );

        if (!condicaoEncontrada) {
            // Condição não encontrada na lista à vista, não fazer nada
            return;
        }

        // Verificar se o campo 'descricao' (dias) é diferente de vazio ou zero
        const dias = parseInt(condicaoEncontrada.descricao, 10);

        if (isNaN(dias) || dias === 0) {
            // É à vista (0 dias), não fazer nada
            return;
        }

        // Não é à vista - calcular nova data de vencimento
        this.calcularNovaDataVencimento(dias);
    }

    /**
     * Calcula e atualiza a data de vencimento baseado nos dias da condição
     * Se a data já foi calculada (no modal), usa ela ao invés de recalcular
     * @param dias - Número de dias para somar à data de emissão
     */
    calcularNovaDataVencimento(dias: number) {
        let novaDataVencimento: Date;

        // Se já temos uma data calculada (do modal), usa ela
        if (this.novaDataVencimentoCalculada) {
            novaDataVencimento = this.novaDataVencimentoCalculada;
        } else {
            // Caso contrário, calcula agora
            if (!this.protocolo.dataEmissaoNf) {
                return;
            }
            const dataEmissao = moment(this.protocolo.dataEmissaoNf);
            novaDataVencimento = dataEmissao.add(dias, 'days').toDate();
        }

        // Atualizar protocolo com a nova data de vencimento
        this.protocolo.dataVencimentoNf = novaDataVencimento;

        // Verificar se o controle existe antes de acessar
        if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
            this.fichaForm.controls["frmVencimento"].setValue(novaDataVencimento);
        }

        // Atualizar o campo de condição de pagamento com o valor do pedido
        if (this.pedidoSendoProcessado && this.pedidoSendoProcessado.condicaoPagamento) {
            this.protocolo.condicaoPagamento = this.pedidoSendoProcessado.condicaoPagamento;
        }

        // Forçar detecção de mudanças antes de desabilitar
        this.cdr.detectChanges();

        // Sempre bloquear campo de vencimento
        if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
            this.fichaForm.controls["frmVencimento"].disable();
        }

        // Recalcular data fixa de pagamento se necessário
        this.recalcularDataFixaPagamento(novaDataVencimento);

        // Recalcular e atualizar a condição de pagamento com base nas novas datas
        this.validarCondicaoPagamento();

        // Limpar variáveis temporárias após processar tudo
        this.novaDataVencimentoCalculada = null;
        this.pedidoSendoProcessado = null;
    }

    /**
     * Recalcula a data fixa de pagamento quando a data de vencimento é alterada
     * Quando fornecedor tem data fixa, o vencimento também é ajustado para a data fixa
     * @param novaDataVencimento - Nova data de vencimento
     */
    recalcularDataFixaPagamento(novaDataVencimento: Date) {
        // Só recalcula se fornecedor tem data fixa
        if (this.fornecedor && this.fornecedor.dataFixa && novaDataVencimento) {
            // verificaDataVencimento retorna um timestamp, precisa converter para Date
            const dataFixaTimestamp = this.verificaDataVencimento(novaDataVencimento);
            const dataFixa = new Date(dataFixaTimestamp);

            // Atualizar protocolo e form control (protocolo.dataFixaPagamento é string no formato DD/MM/YYYY)
            this.protocolo.dataFixaPagamento = moment(dataFixa).format('DD/MM/YYYY');
            this.fichaForm.controls["frmDataFixaPag"].setValue(
                this.protocolo.dataFixaPagamento
            );

            // Quando fornecedor tem data fixa, o vencimento deve ser igual à data fixa
            this.protocolo.dataVencimentoNf = dataFixa;
            if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
                this.fichaForm.controls["frmVencimento"].setValue(dataFixa);
            }
        }
    }

    carregarMedicao(pedidos: PedidoAssociado[], produtos: Produto[]) {
        if (pedidos !== null) {
            this.arrMedicao = [].concat
                .apply([], pedidos.map((pedidos) => pedidos.produtos))
                .map((produtos) => produtos.medicoes)
                .flat();

            if (this.arrMedicao.length === 0) {
                this.dataSourceMedicao = new MatTableDataSource<Medicao>([]);
                return;
            }
        }

        if (produtos !== null) {
            this.arrMedicao = [].concat
                .apply([], produtos.map((produtos) => produtos.medicoes))
                .flat();

            if (this.arrMedicao.length === 0) {
                this.dataSourceMedicao = new MatTableDataSource<Medicao>([]);
                return;
            }
        }

        const compareAceite = (a, b) => {
            if (a.aceite === b.aceite) {
                return 0;
            } else if (a.aceite) {
                return -1;
            } else {
                return 1;
            }
        };

        this.ordenacaoMedicao = this.arrMedicao.slice().sort(compareAceite);
        const agrupamento = this.groupByMedicoes(
            this.ordenacaoMedicao,
            "codigoMedicao"
        );

        this.dataSourceMedicao = new MatTableDataSource<Medicao>(agrupamento);
        this.dataSourceMedicao.paginator = this.medicaoPaginator;

        if (this.tipoOperacao === TipoOperacao.Consulta) {
            this.selectionMedicao.select(...this.dataSourceMedicao.data);
        }
    }

    carregarPedido(pedidos: PedidoAssociado[]) {
        this.protocolo.pedidos = pedidos;
        this.dataSourcePedido = new MatTableDataSource<PedidoAssociado>(
            this.protocolo.pedidos
        );
        this.dataSourcePedido.paginator = this.pedidoPaginator;
    }

    incluirRateiosProdutos() {
        this.protocolo.rateios = [] as RateioDespesas[];
        this.protocolo.produtos = [] as Produto[];

        this.lstPedidoAssociado.map((pedido) => {
            if (pedido.tipo === "LOF Obra" || pedido.tipo === "Cotação Obra") {
                this.protocolo.geraPagamento = false;
            }

            pedido.produtos.map((produto, i) => {
                produto.item = produto.identificador;
                this.protocolo.produtos.push(produto);
            });

            //Limpando Medições do Protocolo
            this.protocolo.produtos.map((p) => {
                p.medicoes = [];
            });

            this.atualizarQuantidadeValorNosProdutos();

            pedido.rateios.map((rateio) => {
                this.protocolo.rateios.push(rateio);
            });

            this.atualizarValorTotalNosRateios(true);
            this.protocolo.rateios = this.ordenarRateios(
                this.protocolo.rateios
            );
            this.protocolo.rateios = this.ValidaDescricaoRateio(
                this.protocolo.rateios
            );
        });

        this.onPedidoAdded();
    }

    deleteRowPedido(row) {
        this.protocolo.pedidos = this.protocolo.pedidos || undefined;
        if (this.protocolo.pedidos !== undefined) {
            const pedidoPreExistente = this.protocolo.pedidos.filter(
                (x) => x.criacaoAutomaticaMrvPag === false
            ).length;
            if (pedidoPreExistente > 0) {
                const dialogRef = this.ExibeMensagem(
                    "Pedidos",
                    "ATENÇÃO! Ao excluir um pedido pré-existente, todos os pedidos serão desassociados do protocolo, junto com seus produtos e rateios. Confirma a desassociação dos pedidos?",
                    "confirm"
                );

                dialogRef.afterClosed().subscribe((confirm) => {
                    if (confirm != null && confirm) {
                        let codPedidoRemovido = row.codigoPedido.toString();
                        this.protocolo.pedidos = this.protocolo.pedidos.filter(
                            (p) => p.codigoPedido !== codPedidoRemovido
                        );
                        this.protocolo.produtos =
                            this.protocolo.produtos.filter(
                                (p) =>
                                    p.idSapPedidoContrato !== codPedidoRemovido
                            );
                        this.protocolo.rateios = this.protocolo.rateios.filter(
                            (r) => {
                                return this.protocolo.produtos.some((p) => {
                                    return (
                                        Number(r.item) === Number(p.item) &&
                                        r.idSapPedidoContrato ===
                                            p.idSapPedidoContrato
                                    );
                                });
                            }
                        );

                        if (this.protocolo.pedidos.length < 1) {
                            this.pedidoPreexistente = false;
                        }

                        this.protocolo.geraPagamento = true;
                        this.carregarPedido(this.protocolo.pedidos);
                        this.exibirProdutos();
                        this.preencherDataSourceRateios(this.protocolo.rateios);
                        this.limparMedicoes();

                        if (this.numerosPedidos) {
                            const numerosPedidos: string[] = this.numerosPedidos
                                .split(",")
                                .filter((n) => n != codPedidoRemovido);
                            if (numerosPedidos.length == 0) {
                                this.numerosPedidos = "";
                            } else {
                                numerosPedidos.forEach((value, index) => {
                                    if (index === 0) {
                                        this.numerosPedidos = value;
                                    } else {
                                        this.numerosPedidos =
                                            this.numerosPedidos + "," + value;
                                    }
                                });
                            }
                        }

                        this.onStepChanged(this.etapaAtual, PageDirection.back);
                        // Se não houver mais pedidos associados, destrava os campos de vencimento e emissão
                        if (!this.protocolo.pedidos || this.protocolo.pedidos.length === 0) {
                            // Destravar campos de data
                            if (this.fichaForm && this.fichaForm.controls["frmVencimento"]) {
                                this.fichaForm.controls["frmVencimento"].enable();
                            }

                            if (this.fichaForm && this.fichaForm.controls["frmDtEmissao"]) {
                                this.fichaForm.controls["frmDtEmissao"].enable();
                            }

                            // Limpar flag de parcelado e campos relacionados
                            this.protocolo.parcelado = false;
                            this.parcelado = false;
                            this.protocolo.condicaoParcelamento = null;
                            this.protocolo.condicaoPagamento = null;
                            this.protocolo.descricaoCondicaoPagamento = null;

                            // Limpar os form controls de condição de pagamento
                            if (this.fichaForm && this.fichaForm.controls["frmCondicaoPg"]) {
                                this.fichaForm.controls["frmCondicaoPg"].setValue(null);
                            }
                            if (this.fichaForm && this.fichaForm.controls["frmCondicaoPar"]) {
                                this.fichaForm.controls["frmCondicaoPar"].setValue(null);
                            }

                            // Destravar campos de ficha do protocolo
                            this.destravarCamposAposRemoverPedidos();

                            this.cdr.detectChanges();
                        }
                    }
                });
            } else {
                const dialog = this.ExibeMensagem(
                    "Pedidos",
                    "ATENÇÃO! Você está tentando excluir o pedido do protocolo. Esse pedido foi criado automaticamente na criação do protocolo e a sua exclusão acarreta no cancelamento do protocolo e essa ação não poderá ser desfeita. Confirma a exclusão do protocolo?",
                    "confirm"
                );

                dialog.afterClosed().subscribe((confirm) => {
                    if (confirm != null && confirm) {
                        this.cancelarProtocolo();
                    }
                });
            }
        }
    }

    limparMedicoes() {
        this.dataSourceMedicao = new MatTableDataSource<Medicao>([]);
    }

    /**
     * Trava os campos da ficha do protocolo após associar um pedido
     * para evitar inconsistências entre os dados do pedido e do protocolo
     */
    travarCamposAposAssociarPedido() {
        if (!this.fichaForm) return;

        // Travar campos de empresa
        if (this.fichaForm.controls["frmCnpjEmpresa"]) {
            this.fichaForm.controls["frmCnpjEmpresa"].disable();
        }
        if (this.fichaForm.controls["frmNomeEmpresa"]) {
            this.fichaForm.controls["frmNomeEmpresa"].disable();
        }

        // Travar centro logístico
        if (this.frmCentroLogistico) {
            this.frmCentroLogistico.disable();
        }

        // Travar campos de fornecedor
        if (this.fichaForm.controls["frmCnpjFornecedor"]) {
            this.fichaForm.controls["frmCnpjFornecedor"].disable();
        }
        if (this.fichaForm.controls["frmNomeFornecedor"]) {
            this.fichaForm.controls["frmNomeFornecedor"].disable();
        }

        // Travar número do documento
        if (this.fichaForm.controls["frmNumDocumento"]) {
            this.fichaForm.controls["frmNumDocumento"].disable();
        }

        // Travar data de emissão
        if (this.fichaForm.controls["frmDtEmissao"]) {
            this.fichaForm.controls["frmDtEmissao"].disable();
        }

        // Travar data de vencimento
        if (this.fichaForm.controls["frmVencimento"]) {
            this.fichaForm.controls["frmVencimento"].disable();
        }

        // Travar toggle de parcelado
        if (this.fichaForm.controls["frmParcelado"]) {
            this.fichaForm.controls["frmParcelado"].disable();
        }

        // Travar condição de parcelamento se estiver visível
        if (this.parcelado && this.fichaForm.controls["frmCondicaoPar"]) {
            this.fichaForm.controls["frmCondicaoPar"].disable();
        }

        this.cdr.detectChanges();
    }

    /**
     * Destrava os campos da ficha do protocolo após remover todos os pedidos
     */
    destravarCamposAposRemoverPedidos() {
        if (!this.fichaForm) return;

        // Destravar campos de empresa
        if (this.fichaForm.controls["frmCnpjEmpresa"]) {
            this.fichaForm.controls["frmCnpjEmpresa"].enable();
        }
        if (this.fichaForm.controls["frmNomeEmpresa"]) {
            this.fichaForm.controls["frmNomeEmpresa"].enable();
        }

        // Destravar centro logístico
        if (this.frmCentroLogistico) {
            this.frmCentroLogistico.enable();
        }

        // Destravar campos de fornecedor
        if (this.fichaForm.controls["frmCnpjFornecedor"]) {
            this.fichaForm.controls["frmCnpjFornecedor"].enable();
        }
        if (this.fichaForm.controls["frmNomeFornecedor"]) {
            this.fichaForm.controls["frmNomeFornecedor"].enable();
        }

        // Destravar número do documento
        if (this.fichaForm.controls["frmNumDocumento"]) {
            this.fichaForm.controls["frmNumDocumento"].enable();
        }

        // Destravar toggle de parcelado
        if (this.fichaForm.controls["frmParcelado"]) {
            this.fichaForm.controls["frmParcelado"].enable();
        }

        // Destravar condição de parcelamento
        if (this.fichaForm.controls["frmCondicaoPar"]) {
            this.fichaForm.controls["frmCondicaoPar"].enable();
        }

        this.cdr.detectChanges();
    }

    exibeTelaPedidos() {
        if (
            this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.GuiaISSComplementar &&
            !this.protocolo.modoEdicao
        ) {
            return false;
        }

        if (
            !this.protocolo.modoEdicao &&
            (this.protocolo.idTipoFiscal ===
                TipoFiscalEnum.SimplesRemessa.toString() ||
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Bonificacao.toString() ||
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Brinde.toString())
        ) {
            return false;
        }

        this.protocolo.idTipoFiscal = this.protocolo.idTipoFiscal || "0";

        if (
            this.tipoFiscalBloqueado.indexOf(this.protocolo.idTipoFiscal) === -1
        ) {
            return true;
        }

        return false;
    }

    onSubmitProdutos() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            this.dataSourceMedicao.data.length > 0
                ? this.onStepChanged(this.etapaAtual, PageDirection.forward)
                : this.onStepChanged(4, PageDirection.forward);
            return;
        }

        if (
            this.fichaProdutoIsValid(true, false) &&
            this.protocolo.codEmpresa !== "FKIT"
        ) {
            if (this.protocolo.idTipoDocumento == 80) {
                this.salvarProtocoloTerreno = true;
            }

            this.dataSourceMedicao.data.length > 0
                ? this.onStepChanged(this.etapaAtual, PageDirection.forward)
                : this.onStepChanged(4, PageDirection.forward);
        }
    }

    recalcularRateioPedidoPreExistente() {
        if (this.pedidoPreexistente) {
            this.atualizarValorTotalNosRateios(false);
        }
    }

    onSubmitMedicoes() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            this.onStepChanged(this.etapaAtual, PageDirection.forward);
            return;
        }

        let valorTotalParaSerMedido = this.obterValorTotalParaSerMedido();

        if (valorTotalParaSerMedido > -10 && valorTotalParaSerMedido < 10) {
            this.onStepChanged(this.etapaAtual, PageDirection.forward);
        } else {
            this.messageModel = new Message(
                "Atenção",
                "",
                `A diferença do valor total das medições não pode ser maior que R$10 reais, seja para mais ou para menos.`,
                "warning"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
        }
    }

    salvarMedicaoProtocolo() {
        this.protocolo.produtos.map((p) => {
            p.medicoes = [];
        });

        const obj = [];
        this.selectionMedicao.selected.forEach((item) => {
            obj.push(item);
        });

        obj.forEach((item) => {
            this.protocolo.produtos.map((p) => {
                p.medicoes.push(...item.Elements);
            });
        });
    }

    selecionarItemMedicao(element: any): void {
        this.selectionMedicao.toggle(element);
        this.salvarMedicaoProtocolo();
    }

    desabilitarCheckMedicao(element: Medicao) {
        if (
            !element.aceite ||
            (this.obterValorTotalParaSerMedido() > -10 &&
                this.obterValorTotalParaSerMedido() < 10 &&
                !this.selectionMedicao.isSelected(element)) ||
            this.tipoOperacao === TipoOperacao.Consulta
        ) {
            return true;
        }

        return false;
    }

    fichaProdutoIsValid(exibirMsgErro: boolean, origemBotaoEnviarProtocolo) {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        let fichaPedidoValido = this.fichaPedidoIsValid();
        let produtoValido = this.produtosValidos(
            exibirMsgErro,
            origemBotaoEnviarProtocolo
        );
        let justificativaValida = this.validarJustificativa();

        if (fichaPedidoValido && produtoValido && justificativaValida) {
            if (this.lstPedidoAssociado.length > 0) {
                this.bloquearBotaoSalvar = false;
            }
            return true;
        }

        return false;
    }

    produtosValidos(exibirMsgErro: boolean, origemBotaoEnviarProtocolo) {
        if (this.dataSourceMedicao.data.length > 0) {
            return true;
        }

        if (
            !this.ValidarSeUsuarioPossuiAcessoParaModificacaoProtocoloTerceiro(
                exibirMsgErro
            )
        ) {
            return false;
        }

        if (
            this.lstPedidoAssociado.length > 0 &&
            !this.ValidarSeValorTotalProtocoloTemDiferenca10ReaisValorTotalProduto(
                exibirMsgErro
            )
        ) {
            return false;
        }

        if (
            this.lstPedidoAssociado.length === 0 &&
            !this.ValidarSeValorTotalProtocoloUltrapassaValorTotalProduto(
                exibirMsgErro
            )
        ) {
            return false;
        }

        if (
            origemBotaoEnviarProtocolo &&
            !this.ValidarSeValorTotalProdutoUltrapassaValorTotalRateioEmDezReaisOuMais(
                exibirMsgErro
            )
        ) {
            return false;
        }

        if (
            origemBotaoEnviarProtocolo &&
            !this.ValidarSeAlgumProdutoEstaComValorSuperiorQuantidadeMaximaPermitida(
                exibirMsgErro
            )
        ) {
            return false;
        }

        if (
            origemBotaoEnviarProtocolo &&
            !this.ValidarSeAlgumProdutoEstaComValorSuperiorQuantidadeMaximaPermitida(
                exibirMsgErro
            )
        ) {
            return false;
        }

        return true;
    }

    validarJustificativa(): boolean {
        const tipoDocumentoSemJustificativa = [
            TipoDocumentoEnum.SomenteMateriais,
            TipoDocumentoEnum.GuiaISSComplementar,
        ];

        if (this.pedidoPreexistente) {
            return true;
        }

        if (
            tipoDocumentoSemJustificativa.indexOf(
                this.protocolo.idTipoDocumento
            ) !== -1
        ) {
            return true;
        }

        if (this.protocolo.pedidos.length > 0) {
            return true;
        }

        if (this.fProduto.justificativa.valid) {
            return true;
        }

        return false;
    }

    justificativaIsRequired() {
        const tipoDocumentoSemJustificativa = [
            TipoDocumentoEnum.SomenteMateriais,
            TipoDocumentoEnum.GuiaISSComplementar,
        ];

        if (this.pedidoPreexistente) {
            return false;
        }

        if (
            tipoDocumentoSemJustificativa.indexOf(
                this.protocolo.idTipoDocumento
            ) !== -1
        ) {
            return false;
        }

        if (this.protocolo.pedidos.length > 0) {
            return false;
        }

        return true;
    }

    deleteRowProduto(row) {
        const dialog = this.ExibeMensagem(
            "Produtos",
            "Confirma a exclusão do item?",
            "confirm"
        );

        dialog.afterClosed().subscribe((confirm) => {
            if (confirm != null && confirm) {
                this.removerProdutoseRateios(row);
            }
        });
    }

    removerProdutoseRateios(row) {
        const indexProd = this.protocolo.produtos.findIndex(
            (p) => p.item === row.item
        );
        this.onDeletedItemRateio(Number(row.item));
        this.protocolo.produtos.splice(indexProd, 1);
        this.exibirProdutos();
    }

    public preencherListaProdutosPedidos() {
        this.pedidoPreexistente = true;
        this.exibirProdutos();
    }

    abrirModalProduto() {
        let filterData: any;
        filterData = {} as FilterData;

        filterData.Fornecedor = this.protocolo.idSapFornecedor || null;
        filterData.TipoDocumento = this.protocolo.idTipoDocumento || null;
        filterData.TipoBuscaBloqueado = true;

        if (filterData.Fornecedor == null || filterData.TipoDocumento == null) {
            return;
        }

        this.produtoModalService.open(filterData).subscribe((result) => {
            let prod: Produto[];
            const newProd = [] as Produto[];
            this.protocolo.produtos = this.protocolo.produtos || [];

            if (result) {
                result.map((element) => {
                    newProd.push(element);
                });
            }
            prod = [...this.protocolo.produtos, ...newProd];
            prod.map((element, index) => {
                element.item = (++index).toString();
                element.identificador = element.item;
            });

            this.protocolo.produtos = prod;
            this.exibirProdutos();
        });
    }

    calcularValorTotal(element) {
        element.quantidadeFormated = element.quantidadeFormated || "0,0";
        element.quantidade = Number(
            element.quantidadeFormated.replace(",", ".")
        );
        element.valorUnitario = element.valorUnitario || 0.0;
        const vlUn = Number(element.valorUnitario);
        const aliquota = Number(
            element.aliquotaIPI.toString().replace(",", ".")
        );
        const valorTotal = element.quantidade * vlUn;

        element.valorTotal = this.arredondar(valorTotal, 2);
        element.ipi = this.arredondar((element.valorTotal * aliquota) / 100, 2);

        if (this.pedidoPreexistente) {
            let produto = this.protocolo.produtos.find(
                (p) =>
                    p.item === element.item.toString() &&
                    p.idSapPedidoContrato ===
                        element.idSapPedidoContrato.toString()
            );
            if (
                produto &&
                Number(element.quantidade) > produto.quantidadeMaxima
            ) {
                this.messageModel = new Message(
                    "Atenção",
                    `Para o Produto "${produto.descricao}" a quantidade máxima permitida é "${produto.quantidadeMaxima}".`,
                    "",
                    "warning"
                );
                this.dialog.open(PopupMessagesNewStyleTestComponent, {
                    data: this.messageModel,
                });
                return;
            }

            this.recalcularRateioPedidoPreExistente();
        }

        this.validacaoValorTotalRateios("Incluir");
    }

    arredondar(number, precision) {
        const factor = Math.pow(10, precision);
        const tempNumber = number * factor;
        const roundedTempNumber = Math.round(tempNumber);

        return roundedTempNumber / factor;
    }

    bloquearPorFaltaPermissaoPedido(): boolean {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return false;
        }
        const pedidosPreExistentes = (this.protocolo.pedidos || []).filter(
            (p) => p.criacaoAutomaticaMrvPag === false
        );
        const criarPedidoAutomatico = pedidosPreExistentes.length === 0;
        return criarPedidoAutomatico && !this.currentUser.criarPedidos;
    }

    produtoIsDisabled() {
        if (this.bloquearPorFaltaPermissaoPedido()) {
            return true;
        }
        return this.fichaPedidoIsValid() ? false : true;
    }

    medicaoIsDisabled() {
        return this.fichaPedidoIsValid() ? false : true;
    }

    produtoInnit() {
        this.etapaAtual = ProtocoloFiscalPageEnum.Produtos;
        this.onStepChanged(this.etapaAtual);
    }

    deleteAllRowsRateio() {
        const dialog = this.exibeMensagem(
            "Rateios",
            "Confirma a exclusão de todos os itens de rateio?",
            "confirm"
        );

        this.loadComponent.startLoading(true);
        dialog.afterClosed().subscribe((confirm) => {
            if (confirm != null && confirm) {
                this.protocolo.rateios = new Array<RateioDespesas>();
                this.dataSourceRateio = new MatTableDataSource<RateioDespesas>(
                    this.protocolo.rateios
                );
            }

            this.loadComponent.startLoading(false);
        });
    }

    deleteRowRateio(item, numeroSerial) {
        const dialog = this.exibeMensagem(
            "Rateios",
            "Confirma a exclusão do rateio?",
            "confirm"
        );

        this.loadComponent.startLoading(true);
        dialog.afterClosed().subscribe((confirm) => {
            if (confirm != null && confirm) {
                this.delete(item, numeroSerial);
            }

            this.loadComponent.startLoading(false);
        });
    }

    delete(item, numeroSerial) {
        const index = this.protocolo.rateios.findIndex(
            (d) => d.item === item && d.numeroSerial === numeroSerial
        );
        this.protocolo.rateios.splice(index, 1);

        this.dataSourceRateio = new MatTableDataSource<RateioDespesas>(
            this.protocolo.rateios
        );

        this.validacaoValorTotalRateios("Excluir");
    }

    exibeMensagem(title: string, message: string, status: string = null) {
        this.messageModel = new Message(title, "", `${message} `, status);
        return this.dialog.open(PopupMessagesNewStyleTestComponent, {
            data: this.messageModel,
        });
    }

    rateioIsDisabled() {
        if (this.bloquearPorFaltaPermissaoPedido()) {
            return true;
        }

        let habilitarRateio = false;

        if (
            this.protocolo.produtos.length > 0 &&
            this.fichaProdutoIsValid(false, false)
        ) {
            habilitarRateio = true;
        }

        return !habilitarRateio;
    }

    rateioInnit() {
        this.etapaAtual = ProtocoloFiscalPageEnum.Ratetio;
        this.onStepChanged(this.etapaAtual);
        this.validacaoValorTotalRateios("Editar");
    }

    validacaoValorTotalRateios(acao: string) {
        let totalSomaRateio = 0.0;

        if (this.protocolo.rateios.length > 0) {
            totalSomaRateio = this.protocolo.rateios
                .map((v) => v.valor)
                .reduce((totalSomaRateio, v) => totalSomaRateio + v);
        }

        totalSomaRateio = this.arredondar(totalSomaRateio, 2);

        if (acao === "Editar") {
            if (!this.valorTotalRateios(totalSomaRateio)) {
                if (this.tipoOperacao === TipoOperacao.Edicao) {
                    this.bloquearBotaoSalvar = true;
                    this.messageModel = new Message(
                        "Atenção",
                        "",
                        `O valor total rateado "R$ ${totalSomaRateio}" não pode ser diferente do valor total da NF "R$ ${this.protocolo.valorTotalComDescontos}".`,
                        "warning"
                    );
                    this.dialog.open(PopupMessagesNewStyleTestComponent, {
                        data: this.messageModel,
                    });
                }
            }
        }

        if (acao === "Incluir" || acao === "Excluir") {
            if (!this.valorTotalRateios(totalSomaRateio)) {
                this.bloquearBotaoSalvar = true;
            } else {
                this.bloquearBotaoSalvar = false;
            }
        }
    }

    valorTotalRateios(totalSomaRateio) {
        if (
            totalSomaRateio !==
                this.arredondar(this.protocolo.valorTotalComDescontos, 2) &&
            this.dataSourceMedicao.data.length === 0
        ) {
            return false;
        }
        return true;
    }

    verificaItemTodos() {
        if (this.protocolo.rateios.length === 0) {
            return false;
        }

        const rateioItemTotal =
            this.protocolo.rateios.find((x) => x.item === 0) || null;
        return rateioItemTotal !== null && rateioItemTotal.item === 0
            ? true
            : false;
    }

    preencherDataSourceRateios(rateios: RateioDespesas[]) {
        if (this.validarRateioPorProduto(rateios)) {
            this.dataSourceRateio = new MatTableDataSource<RateioDespesas>(
                rateios
            );
            this.dataSourceRateio.paginator = this.rateioPaginator;
        } else {
            this.protocolo.rateios = [];
        }
    }

    verificaPedidoAssociado(pedidos: PedidoAssociado[]) {
        if (pedidos.length > 0) {
            this.possuiPedidoAssociado = !pedidos[0].criacaoAutomaticaMrvPag;
        }
    }

    fichaRateioIsValid() {
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        if (
            this.protocolo.modoEdicao &&
            this.currentUser.login !== this.protocolo.loginResponsavel &&
            !this.currentUser.movimentarProtocoloTerceiros
        ) {
            return false;
        }

        //ROLE: Caso o protocolo tenha pedido pré-existente não se faz necessário validação dos rateios
        if (this.pedidoPreexistente) {
            let valorTotalParaSerMedido = this.obterValorTotalParaSerMedido();

            if (
                this.dataSourceMedicao.data.length &&
                valorTotalParaSerMedido > -10 &&
                valorTotalParaSerMedido < 10
            ) {
                return true;
            }

            //Caso Não Tenham Medições o Botão Habilitadp
            if (!this.dataSourceMedicao.data.length) {
                return true;
            }

            return false;
        }

        if (
            this.protocolo.idTipoDocumento === 20 &&
            this.protocolo.idTipoFiscal === "10" &&
            this.fichaProdutoIsValid(false, false)
        ) {
            return true;
        }

        if (
            this.tipoOperacao === TipoOperacao.Edicao &&
            this.protocolo.produtos.length === 0
        ) {
            return false;
        }

        //ROLE: Caso o protocolo não seja do tipo Simples Remessa e não possua pedido pré existente é necessário ter rateio informado
        if (
            !this.fichaProdutoIsValid(false, false) ||
            (!this.pedidoPreexistente &&
                this.protocolo.idTipoFiscal !==
                    TipoFiscalEnum.SimplesRemessa.toString() &&
                this.protocolo.rateios.length < 1)
        ) {
            return false;
        }

        return true;
    }

    fichaMedicoesIsValid() {
        let valorTotalParaSerMedido = this.obterValorTotalParaSerMedido();

        if (valorTotalParaSerMedido > -10 && valorTotalParaSerMedido < 10) {
            this.onStepChanged(this.etapaAtual, PageDirection.forward);
        } else {
            this.messageModel = new Message(
                "Atenção",
                "",
                `A diferença do valor total das medições não pode ser maior que R$10 reais, seja para mais ou para menos.`,
                "warning"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
        }
    }

    incluirRateioTabela() {
        const listaRateioAdicionado = new Array<RateioDespesas>();
        this.rateioAdicionado.idProdutoAssociado = this.produtoSelected.item;
        listaRateioAdicionado.push(this.rateioAdicionado);

        if (!this.quantidadeRateiosValido()) {
            this.messageModel = new Message(
                "Atenção",
                "Para o Tipo Fiscal selecionado é permitido apenas um coletor por produto.",
                "",
                "warning"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
            return;
        }

        if (!this.rateioOpcaoTodoItemValido()) {
            this.messageModel = new Message(
                "Atenção",
                "Para o Tipo Fiscal selecionado é permitido unicamente rateio de todos os itens ou de produtos específicos.",
                "",
                "warning"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
            return;
        }

        if (this.isProtocoloTerceiros()) {
            this.messageModel = new Message(
                "Atenção",
                "Seu usuário não possui acesso para modificação de protocolos de terceiros",
                "",
                "warning"
            );
            this.dialog.open(PopupMessagesNewStyleTestComponent, {
                data: this.messageModel,
            });
            return;
        }

        if (
            this.rateioDespesasForm.invalid ||
            !this.valorFormularioValido(
                Number(this.rateioDespesasForm.value.frmValorDespesa.toFixed(2))
            )
        ) {
            return;
        }

        if (this.empresaInvalida()) {
            return;
        }

        if (this.produtosInvalidos()) {
            return;
        }

        if (
            this.produtoSelected.item !== "0" &&
            (this.valorRateioPorProdutoInvalido(this.rateioAdicionado) ||
                this.valorTotalTodosProdutosPorTodosRateiosInvalido(
                    this.rateioAdicionado
                ))
        ) {
            this.loadComponent.startLoading(false);
            return;
        }

        this.inserirRateios(listaRateioAdicionado);
    }

    valorFormularioValido(valorInformado: number) {
        if (valorInformado <= 0) {
            this.exibeMensagem(
                "Problema ao inserir o rateio",
                "O valor informado é inválido",
                "warning"
            );
            return false;
        }
        return true;
    }

    empresaInvalida() {
        if (this.protocolo.codEmpresa == null) {
            this.exibeMensagem(
                "Problema ao inserir o rateio",
                "Por favor, selecione a empresa na Ficha do Protocolo.",
                "warning"
            );
            return true;
        } else {
            this.loadComponent.startLoading(false);
            return false;
        }
    }

    produtosInvalidos() {
        if (this.protocolo.produtos == null) {
            this.exibeMensagem(
                "Problema ao inserir o rateio",
                "Por favor, insira pelo menos um Produto ou Serviço.",
                "warning"
            );
            return true;
        } else {
            this.loadComponent.startLoading(false);
            return false;
        }
    }

    valorRateioPorProdutoInvalido(rateio: RateioDespesas) {
        let rateiosPorProduto = this.protocolo.rateios.filter(
            (p) => p.idProdutoAssociado === this.produtoSelected.item
        );
        if (this.protocolo.pedidos.length > 0) {
            rateiosPorProduto = rateiosPorProduto.filter(
                (r) =>
                    r.idSapPedidoContrato ===
                    this.produtoSelected.idSapPedidoContrato
            );
        }
        let valorTotalProdutoRateio = rateiosPorProduto.reduce(
            (sum, c) => sum + c.valor,
            0
        );
        valorTotalProdutoRateio = valorTotalProdutoRateio + rateio.valor;
        valorTotalProdutoRateio = parseFloat(
            valorTotalProdutoRateio.toFixed(2)
        );
        if (valorTotalProdutoRateio > this.produtoSelected.valorTotal) {
            this.exibeMensagem(
                "Problema ao inserir o rateio",
                "A soma do valor rateado para o produto(s) não pode ser superior ao valor do produto.",
                "warning"
            );
            return true;
        } else {
            return false;
        }
    }

    valorTotalTodosProdutosPorTodosRateiosInvalido(rateio: RateioDespesas) {
        let valorTotalProduto = this.obterValorTotalProdutosComArredondamento();
        let valorTotalRateio = this.obterValorTotalRateiosComArredondamento();
        let valorTotalRateioSomadoComAtual = valorTotalRateio + rateio.valor;
        valorTotalRateioSomadoComAtual = parseFloat(
            valorTotalRateioSomadoComAtual.toFixed(2)
        );
        if (valorTotalRateioSomadoComAtual > valorTotalProduto) {
            this.exibeMensagem(
                "Problema ao inserir o rateio",
                "O valor total do(s) rateio(s) não pode(m) ser superior(es) ao total do(s) produto(s).",
                "warning"
            );
            return true;
        } else {
            return false;
        }
    }

    validarRateioPorProduto(rateios: RateioDespesas[]): boolean {
        let valido = true;

        if (
            this.tipoOperacao !== TipoOperacao.Consulta &&
            rateios.findIndex((x) => x.item) !== -1
        ) {
            this.protocolo.produtos.forEach((p) => {
                let valorTotalProdutoArredondado = this.arredondar(
                    p.valorTotal,
                    2
                );

                let rateiosPorProduto = rateios.filter(
                    (r) => r.item && r.item.toString() === p.item
                );
                if (this.protocolo.pedidos.length > 0) {
                    rateiosPorProduto = rateiosPorProduto.filter(
                        (r) => r.idSapPedidoContrato === p.idSapPedidoContrato
                    );
                }

                let valorTotalRateioPorProduto = rateiosPorProduto.reduce(
                    (sum, c) => sum + c.valor,
                    0
                );
                let valorTotalRateioPorProdutoArredondado = this.arredondar(
                    valorTotalRateioPorProduto,
                    2
                );

                if (
                    ((this.protocolo.pedidos.length > 0 &&
                        rateiosPorProduto.length <= 1) ||
                        this.protocolo.pedidos.length == 0) &&
                    valorTotalRateioPorProdutoArredondado >
                        valorTotalProdutoArredondado
                ) {
                    this.exibeMensagem(
                        "Problema ao inserir o rateio",
                        `A soma do valor rateado para o produto \"Item: ${p.item} - ${p.descricao}\" não pode ser superior ao valor do produto. <br />Valor rateado: ${valorTotalRateioPorProdutoArredondado} <br /> Valor Produto: ${valorTotalProdutoArredondado} `,
                        "warning"
                    );
                    valido = false;
                }
            });
        }

        return valido;
    }

    inserirRateios(rateios: RateioDespesas[]) {
        // Valida Coletores de Custo
        this.loadComponent.startLoading(true);
        this.coletorCustosService
            .ValidarColetoresEmpresa(
                rateios,
                this.protocolo.codEmpresa,
                this.protocolo.divisao
            )
            .subscribe(
                (data) => {
                    this.coletoresCusto = data.data;
                },
                (err) => {
                    console.error(err);
                },
                () => {
                    if (this.coletoresCusto != null) {
                        this.verificaColetoresInvalidos(
                            this.coletoresCusto,
                            rateios
                        );
                        this.verifingColetor = false;
                    }
                }
            )
            .add(() => {
                this.loadComponent.startLoading(false);
            });
    }

    verificaColetoresInvalidos(
        coletores: ColetorCustos[],
        rateios: RateioDespesas[]
    ) {
        this.coletoresCustoError = new Array<ColetorCustos>();

        coletores.forEach((cc) => {
            if (cc.status === "E") {
                this.coletoresCustoError.push(cc);
            }
        });

        if (this.coletoresCustoError.length > 0) {
            this.dialog.open(PopUpColetoresComponent, {
                data: this.coletoresCustoError,
            });
        } else {
            this.incluirRateioDataSource(rateios);
        }
    }

    incluirRateioDataSource(rateios: RateioDespesas[]) {
        if (rateios.length === 1) {
            this.itemProduto++;
            rateios[0].item = Number(this.produtoSelected.item);
            rateios[0].numeroSerial = this.obterProximoNumeroSerial(
                Number(this.produtoSelected.item)
            );
            rateios[0].nomeTipoDespesa =
                this.produtoSelected.codigoPedido != null
                    ? this.produtoSelected.codigoPedido.toString()
                    : "";
            rateios[0].contaRazao =
                this.obterValorTotalProdutosComArredondamento() != null
                    ? this.obterValorTotalProdutosComArredondamento().toString()
                    : "";
            rateios[0].usuarioAlteracao = this.currentUser.login;
            rateios[0].usuarioCadastro = this.currentUser.login;
            rateios[0].valor =
                rateios[0].valor != null
                    ? Number(rateios[0].valor.toFixed(5))
                    : 0;
            rateios[0].identificacaoColetor = rateios[0].identificacaoColetor
                .toUpperCase()
                .replace(" ", "");
            this.pesColetorCustos = false;

            if (
                this.protocolo.rateios.reduce((sum, c) => sum + c.valor, 0) +
                    rateios[0].valor >
                this.cabecalhoProtocolo.valor
            ) {
                this.exibeMensagemValorRateios();
                return;
            }
        }

        // Add rateioDespesas object in table datasouce
        rateios.forEach((r) => this.protocolo.rateios.push(r));

        this.preencherDataSourceRateios(this.protocolo.rateios);

        //Validação Rateios
        this.validacaoValorTotalRateios("Incluir");

        // CLEAR RATEIO FIELDS
        this.rateioAdicionado = {} as RateioDespesas;
        this.produtoSelected = {} as Produto;

        this.clearValidatorsAndResetRateioDespesasForm();
    }

    clearValidatorsAndResetRateioDespesasForm() {
        // Limpar campos e validações
        this.rateioDespesasForm.reset();
        this.rateioDespesasForm.clearValidators();

        // Limpar mensagens de erro
        Object.keys(this.rateioDespesasForm.controls).forEach((key) => {
            this.rateioDespesasForm.controls[key].setErrors(null);
        });

        // Marcar controles como intocados e não modificados
        this.rateioDespesasForm.markAsPristine();
        this.rateioDespesasForm.markAsUntouched();
    }

    exibeMensagemValorRateios() {
        this.exibeMensagem(
            "Problema ao inserir o rateio",
            "O valor do total dos rateios será maior que o valor inserido na ficha do protocolo. Tente um valor menor.",
            "warning"
        );
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSourceRateio.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSourceRateio.data.forEach((row) =>
                  this.selection.select(row)
              );
    }

    isAllSelectedMedicao() {
        const numSelected = this.selectionMedicao.selected.length;
        const numRows = this.dataSourceMedicao.data.filter(
            (item) => item.aceite === true
        ).length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        this.isAllSelectedMedicao()
            ? this.selectionMedicao.clear()
            : this.selectionMedicao.select(
                  ...this.dataSourceMedicao.data.filter(
                      (item) =>
                          item.aceite === true &&
                          !this.desabilitarCheckMedicao(item)
                  )
              );

        this.salvarMedicaoProtocolo();
    }

    getErrorMessageNumOperacao() {
        if (this.fRateio.frmNumOperacao.hasError("maxlength")) {
            return "O número da operação deve possuir no máximo 4 caracteres.";
        } else {
            return "Numero da operação é obrigatório quando o tipo de coletor é igual a Diagrama de Rede";
        }
    }

    pesquisarColetorCustos() {
        let confirmacaoTermo: string;

        this.loadComponent.startLoading(true);
        const dialogRef = this.dialog.open(PopupColetorCustosComponent);
        dialogRef.afterClosed().subscribe((result) => {
            confirmacaoTermo = result;
            if (confirmacaoTermo !== "") {
                this.rateioAdicionado.identificacaoColetor = confirmacaoTermo;
            }

            this.loadComponent.startLoading(false);
        });
    }

    verificaDiagramaDeRede() {
        localStorage.setItem(
            "tipoColetor",
            JSON.stringify(
                this.rateioDespesasForm.controls["frmTipoColetor"].value
            )
        );
        if (
            this.rateioDespesasForm.controls["frmTipoColetor"].value !==
            "undefined"
        ) {
            this.pesColetorCustos = true;
        } else {
            this.pesColetorCustos = false;
        }

        if (this.rateioAdicionado.codTipoColetor != "N") {
            this.rateioDespesasForm.controls["frmNumOperacao"].disable();
            this.rateioAdicionado.operacaoSubNumero = "";
            this.diagramaDeRede = false;
        } else {
            this.rateioDespesasForm.controls["frmNumOperacao"].enable();
            this.diagramaDeRede = true;
        }

        if (this.rateioAdicionado.codTipoColetor === "A") {
            this.rateioDespesasForm.controls["frmNumOperacao"].enable();
        }

        this.limparColetorCustos();
    }

    limparRateio() {
        this.protocolo.rateios = [] as RateioDespesas[];
    }

    limparColetorCustos() {
        const frmColetorCustos =
            this.rateioDespesasForm?.get("frmColetorCustos");

        if (frmColetorCustos) {
            frmColetorCustos.setValue("");
            frmColetorCustos.setErrors(null);
        }
    }

    voltar() {
        if (
            this.etapaAtual === ProtocoloFiscalPageEnum.Produtos &&
            !this.exibeTelaPedidos()
        ) {
            this.etapaAtual = ProtocoloFiscalPageEnum.FichaProtocolo;
            this.onStepChanged(ProtocoloFiscalPageEnum.FichaProtocolo);
            return;
        }

        this.onStepChanged(this.etapaAtual, PageDirection.back);
    }

    aprovadorIsRequired(): boolean {
        if (this.tipoFiscalEhSimplesRemessaBonificacaoBrinde()) {
            return false;
        }

        return this.pedidoPreexistente ||
            this.protocolo.idTipoDocumento === TipoDocumentoEnum.RpaUrbamais ||
            this.protocolo.idTipoDocumento === TipoDocumentoEnum.RPA
            ? false
            : true;
    }

    desabilitarResponsavel() {
        return true;
    }

    desabilitarAprovador() {
        if (this.tipoOperacao === 2 || this.tipoOperacao === 3) return true;

        return false;
    }

    habilitaBotaoCancelar() {
        const statusSemPermissaoCancelamento = [9, 8];
        return this.tipoOperacao !== 1 &&
            statusSemPermissaoCancelamento.indexOf(
                this.protocolo.idStatusNovo
            ) === -1
            ? true
            : false;
    }

    getCondicoesPagamento() {
        this.apiCondicaoPagamento
            .ObterCondicoesPagamento()
            .subscribe((data) => (this.condicoesParcelamento = data.data));
    }

    getIconDeleteFile(nomeDocumento) {
        return this.desativarIconDeleteUploadFile(nomeDocumento)
            ? "delete_forever"
            : "delete";
    }

    visualizarStatus() {
        this.loadComponent.startLoading(true);
        let historico = [] as StatusLogProtocolo[];
        this.apiProtocoloFiscal
            .obterStatusELogProtocolo(this.protocolo.idProtocolo)
            .subscribe(
                (sucesso: any) => {
                    if (sucesso.success === true && sucesso.data) {
                        historico = <StatusLogProtocolo[]>sucesso.data;
                    }
                },
                (error) => {
                    console.log("Error", error);
                    this.snackBarService.exibeSnackBarDanger(
                        "Houve erro na pesquisa. Favor validar Id do Protocolo e tentar novamente",
                        4000
                    );
                },
                () => {
                    historico = historico || [];
                    const status: any = {};
                    status.idProtocolo = this.protocolo.idProtocolo;
                    status.registros = historico;
                    this.dialog.open(StatusProtocoloFiscalModalComponent, {
                        data: status,
                        minWidth: "75%",
                        maxWidth: "75%",
                        maxHeight: "600px",
                    });
                }
            )
            .add(() => this.loadComponent.startLoading(false));
    }

    exibirStatusNovo() {
        this.protocolo.idStatusNovo = this.protocolo.idStatusNovo || null;
        return this.protocolo.idStatusNovo !== null;
    }

    desativarIconDeleteUploadFile(nomeDocumento: string) {
        nomeDocumento = nomeDocumento || "";

        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        if (nomeDocumento !== "") {
            if (
                this.tipoOperacao === TipoOperacao.Edicao &&
                nomeDocumento.toLowerCase().indexOf("xml") !== -1
            ) {
                return true;
            }
        }

        return false;
    }

    onChangeDanfe() {
        this.protocolo.danfe = this.protocolo.codBarras;
        if (this.protocolo.codBarras) {
            this.loadComponent.startLoading(true);
            let element: any;
            this.protocolo.codBarras =
                this.protocolo.codBarras.replace(/\s/g, "") || "";
            this.validarDanfeSefaz(this.protocolo.codBarras.trim());
            this.loadComponent.startLoading(false);

            if (this.danfeValidaSefaz) {
                this.loadComponent.startLoading(true);
                setTimeout(() => {}, 2000);

                this.LstUploadFiles = this.LstUploadFiles || [];
                if (
                    this.LstUploadFiles.filter(
                        (p) => p.toLowerCase().indexOf("xml") !== -1
                    ).length === 0 &&
                    this.protocolo.codBarras !== ""
                ) {
                    this.apiDocumentoXml
                        .DownloadNFeUCM(this.protocolo.codBarras)
                        .subscribe(
                            (retorno) => {
                                element = retorno;
                                if (
                                    element?.data != null &&
                                    element.data.success === false
                                ) {
                                    this.loadComponent.startLoading(false);
                                    if (element.data.data?.codigo === "XML_NAO_ENCONTRADO") {
                                        this.dialog.open(
                                            PopupMessagesNewStyleTestComponent,
                                            {
                                                data: new Message(
                                                    "Não encontramos o XML da Nota Fiscal",
                                                    "O XML da Nota Fiscal ainda não foi enviado para o repositório da MRV pelo fornecedor.\n\nO que fazer:\n• Se você tem o arquivo XML da nota, anexe-o junto com a nota no início do cadastro.\n• Se não tiver, peça para o fornecedor enviar o XML para o e-mail: nfe@mrv.com.br\n• Após o envio, aguarde alguns minutos antes de tentar novamente.",
                                                    "",
                                                    "warning"
                                                ),
                                            }
                                        );
                                    } else {
                                        this.dialog.open(
                                            PopupMessagesNewStyleTestComponent,
                                            {
                                                data: new Message(
                                                    "Erro",
                                                    element.data.message,
                                                    "",
                                                    "error"
                                                ),
                                            }
                                        );
                                    }
                                    return;
                                } else {
                                    this.downloadDanfeUCM = true;
                                    this.preencherProtocoloComXml(element.data);
                                }
                                this.loadComponent.startLoading(false);
                            },
                            (erro) => console.log(erro)
                        );
                }
            }
        }
    }

    formBuilderTipoDocumento() {
        this.tipoDocumentoForm = this.formBuilder.group({
            frmStatusNovoProtocolo: [""],
            frmStatusProtocolo: [""],
            frmTipoDoc: ["", Validators.required],
            frmDescricaoStatusProtocolo: [""],
            frmSistemas: [""],
            frmStatusMotivo: [""],
        });
    }

    formBuilderFichaProtocolo() {
        this.fichaForm = this.formBuilder.group({
            frmCnpjEmpresa: [
                "",
                Validators.compose([
                    Validators.required,
                    Validators.minLength(14),
                ]),
            ],
            frmCnpjFornecedor: ["", Validators.compose([Validators.required])],
            frmNomeEmpresa: ["", Validators.required],
            frmNomeFornecedor: ["", Validators.required],
            frmAprovador: [""],
            frmCentroLogistico: ["", Validators.required],
            frmDtEmissao: ["", Validators.required],
            frmVencimento: [""],
            frmDataCriacao: [""],
            frmHoraCriacao: [""],
            frmHoraAlteracao: [""],
            frmDataAlteracao: [""],
            frmResponsavel: ["", Validators.required],
            frmCriadoPor: [""],
            frmDescNota: ["", Validators.required],
            frmNumDocumento: ["", Validators.required],
            frmValorTotalNf: ["", [this.valorTotalNfValidator]],
            frmParcelado: [""],
            frmCondicaoPg: [""],
            frmDataFixaPag: [""],
            frmCfop: [""],
            frmCondicaoPar: [""],
            frmSerie: [""],
            frmDesconto: [""],
            frmValorSeguro: [""],
            frmValorDespesas: [""],
            frmTipoFiscal: [""],
            frmFrete: [""],
            frmValorTotalIpi: [""],
            frmCodBarras: [""],
            frmMesCorrente: ["", Validators.required],
            frmMotivoCancelamento: [""],
        });
    }

    valorTotalNfValidator(control: FormControl): { [s: string]: boolean } {
        if (control.value === 0) {
            return { valorTotalNfVazio: true };
        }
        return null;
    }

    formBuilderPedido() {
        this.pedidosForm = this.formBuilder.group({
            frmlistaPedidos: [""],
        });
    }

    formBuilderProduto() {
        this.produtosForm = this.formBuilder.group({
            produtosArray: this.formBuilder.array([]),
            justificativa: [""],
        });
    }

    formBuilderRateio() {
        this.rateioDespesasForm = this.formBuilder.group({
            frmNumOperacao: [
                "",
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(4),
                ]),
            ],
            frmColetorCustos: [
                "",
                Validators.compose([
                    Validators.required,
                    this.validacaoTipoRateioTamanho,
                ]),
            ],
            frmValorDespesa: ["", Validators.required],
            frmItem: ["", Validators.required],
            frmTipoColetor: ["", Validators.required],
            frmDescricaoDespesa: [""],
        });
    }

    private _filterCentroLogistico(value: string): string[] {
        if (value !== undefined && value !== null) {
            const filterValue = value.toLowerCase();
            return this.optionsCentroLogistico.filter((x) =>
                x.toLowerCase().includes(filterValue)
            );
        }
    }

    private _filterAprovador(event: any): string[] {
        const filterValue = event.toLowerCase();
        return this.optionsAprovador.filter((option) =>
            option.toLowerCase().includes(filterValue)
        );
    }

    filterDataEmissao = (d: Date): boolean => {
        return d <= new Date();
    };

    applyFilter(filterValue: string) {
        this.dataSourceRateio.filter = filterValue.trim().toLowerCase();
    }

    filterDataVencimento = (d: Date): boolean => {
        const dataAtual: Date = new Date();
        dataAtual.setHours(-24);
        return d >= dataAtual;
    };

    apenasLeituraDanfe() {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraCFOP(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraTipoFiscal(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraCNPJMRV(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraNumeroDocumento(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraSerie(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraCNPJFornecedor(): boolean {
        // Desabilita o campo se não há CNPJ da empresa MRV preenchido
        if (!this.protocolo.cnpjDestinatario || this.protocolo.cnpjDestinatario.trim() === '') {
            return true;
        }

        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraDataEmissao(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraValores(): boolean {
        if (
            (this.protocolo.idTipoDocumento ===
                TipoDocumentoEnum.SomenteMateriais &&
                this.existeArquivoXmlAnexado() &&
                this.protocolo.idTipoFiscal ===
                    TipoFiscalEnum.Normal.toString()) ||
            this.downloadDanfeUCM
        )
            return true;

        return false;
    }

    apenasLeituraDataVencimento(): boolean {
        // Desabilita no modo consulta
        if (this.tipoOperacao === TipoOperacao.Consulta) {
            return true;
        }

        // Desabilita o campo se não há CNPJ da empresa MRV preenchido
        if (!this.protocolo.cnpjDestinatario || this.protocolo.cnpjDestinatario.trim() === '') {
            return true;
        }

        // Lógica original para parcelado
        if (this.parcelado) {
            return true;
        }

        return false;
    }

    tipoFiscalEhSimplesRemessaBonificacaoBrinde(): boolean {
        return (
            this.protocolo.idTipoFiscal ===
                TipoFiscalEnum.SimplesRemessa.toString() ||
            this.protocolo.idTipoFiscal ===
                TipoFiscalEnum.Bonificacao.toString() ||
            this.protocolo.idTipoFiscal === TipoFiscalEnum.Brinde.toString()
        );
    }

    tipoFiscalEhSimplesRemessa(): boolean {
        return (
            this.protocolo.idTipoFiscal ===
            TipoFiscalEnum.SimplesRemessa.toString()
        );
    }

    exibirCampoAprovador(): boolean {
        return !this.tipoFiscalEhSimplesRemessaBonificacaoBrinde();
    }

    quantidadeRateiosValido(): boolean {
        if (
            this.tipoFiscalEhSimplesRemessaBonificacaoBrinde() &&
            this.rateioJaExistenteNoProdutoAssociado()
        ) {
            return false;
        }

        return true;
    }

    rateioJaExistenteNoProdutoAssociado(): boolean {
        if (
            this.protocolo.rateios.length > 0 &&
            this.protocolo.rateios.some(
                (r) =>
                    r.idProdutoAssociado !== undefined &&
                    r.idProdutoAssociado ===
                        this.rateioAdicionado.idProdutoAssociado
            )
        ) {
            return true;
        }

        return false;
    }

    rateioOpcaoTodoItemValido(): boolean {
        if (this.tipoFiscalEhSimplesRemessaBonificacaoBrinde()) {
            if (
                this.rateioComOpcaoTodoItemJaIncluso() &&
                this.rateioAdicionado.idProdutoAssociado !== undefined
            ) {
                return false;
            }

            if (
                this.rateioComOpcaoProdutoEspecificoJaIncluso() &&
                this.rateioAdicionado.idProdutoAssociado === undefined
            ) {
                return false;
            }
        }

        return true;
    }

    validacaoTipoRateioTamanho = (control) => {
        const frmTipoColetor = control.parent?.get("frmTipoColetor");
        const frmColetorCustos = control.parent?.get("frmColetorCustos");

        if (frmTipoColetor && frmColetorCustos) {
            const tipoColetorCusto = frmTipoColetor.value;
            const coletorCusto = frmColetorCustos.value;

            if (tipoColetorCusto === "N" && coletorCusto.length > 12) {
                return {
                    erroTipoRateioValidacao:
                        "Esse tipo de coletor não pode exceder 12 caracteres.",
                };
            }

            if (tipoColetorCusto === "K" && coletorCusto.length > 10) {
                return {
                    erroTipoRateioValidacao:
                        "Esse tipo de coletor não pode exceder 10 caracteres.",
                };
            }
        }

        return null;
    };

    rateioComOpcaoTodoItemJaIncluso(): boolean {
        if (
            this.protocolo.rateios.length > 0 &&
            this.protocolo.rateios.some(
                (r) => r.idProdutoAssociado === undefined
            )
        ) {
            return true;
        }

        return false;
    }

    rateioComOpcaoProdutoEspecificoJaIncluso(): boolean {
        if (
            this.protocolo.rateios.length > 0 &&
            this.protocolo.rateios.some(
                (r) => r.idProdutoAssociado !== undefined
            )
        ) {
            return true;
        }

        return false;
    }

    exibirCampoPlanilhaFiscal(): boolean {
        if (
            this.tipoOperacao !== 2 &&
            !this.pedidoPreexistente &&
            !this.tipoFiscalEhSimplesRemessaBonificacaoBrinde()
        ) {
            return true;
        }

        return false;
    }

    exibirEtapaRateio(): boolean {
        return (
            !this.tipoFiscalEhSimplesRemessa() &&
            this.protocolo.idTipoDocumento !== TipoDocumentoEnum.Terrenos
        );
    }

    obterValorTotalPedidosComArredondamento() {
        this.protocolo.pedidos = this.protocolo.pedidos || [];
        let valorTotal = this.protocolo.pedidos.reduce(
            (sum, c) => sum + Number(c.valorTotal.toString().replace(",", ".")),
            0
        );
        let valorTotalArredondado = this.arredondar(valorTotal, 2);

        return valorTotalArredondado > 0 ? valorTotalArredondado : 0.0;
    }

    obterValorTotalProdutosComArredondamento() {
        this.atualizarQuantidadeValorNosProdutos();

        let valorTotal = this.protocolo.produtos.reduce(
            (sum, p) => sum + this.arredondar(p.valorTotal, 2),
            0
        );
        let valorTotalArredondado = this.arredondar(valorTotal, 2);

        return valorTotalArredondado > 0 ? valorTotalArredondado : 0.0;
    }

    obterValorTotalRateiosComArredondamento() {
        this.protocolo.rateios = this.protocolo.rateios || [];
        let valorTotal = this.protocolo.rateios.reduce(
            (sum, r) => sum + r.valor,
            0
        );
        let valorTotalArredondado = this.arredondar(valorTotal, 2);

        return valorTotalArredondado > 0 ? valorTotalArredondado : 0.0;
    }

    atualizarQuantidadeValorNosProdutos() {
        this.protocolo.produtos = this.protocolo.produtos || [];
        this.atualizarQuantidadeNosProdutos();
        this.atualizarValorTotalNosProdutos();
    }

    atualizarQuantidadeNosProdutos() {
        this.protocolo.produtos.map((p) => {
            p = this.atualizarQuantidadeNoProduto(p);
        });
    }

    atualizarValorTotalNosProdutos() {
        this.protocolo.produtos.map((p) => {
            p = this.atualizarValorTotalComArredondamentoNoProduto(p);
        });
    }

    atualizarQuantidadeNoProduto(produto: Produto): Produto {
        if (!produto.quantidadeMaxima || produto.quantidadeMaxima <= 0) {
            produto.quantidadeMaxima = produto.quantidade;
        }

        if (produto.quantidadeFormated) {
            produto.quantidade = Number(
                produto.quantidadeFormated.toString().replace(",", ".")
            );
        }

        produto.quantidadeFormated = produto.quantidade
            .toString()
            .replace(".", ",");

        return produto;
    }

    atualizarValorTotalComArredondamentoNoProduto(produto: Produto): Produto {
        const valorUnitario = Number(produto.valorUnitario || 0);
        produto.valorTotal = this.arredondar(produto.quantidade * valorUnitario, 2);
        return produto;
    }

    atualizarIdSapProdutoNosProdutos() {
        this.protocolo.produtos = this.protocolo.produtos || [];
        this.protocolo.produtos.map((p) => {
            p = this.atualizarIdSapProdutoNoProduto(p);
        });
    }

    atualizarIdSapProdutoNoProduto(produto: Produto): Produto {
        produto.idSapProdutoFormated = produto.idSapProdutoFormated || null;
        if (produto.idSapProdutoFormated === null) {
            produto.idSapProdutoFormated = +produto.idSapProduto || null;
        }

        return produto;
    }

    atualizarFormBuilderNosProdutos() {
        this.produtosArray.clear();
        this.protocolo.produtos.map((p) => {
            this.produtosArray.push(
                this.formBuilder.group({
                    frmQuantidade: [""],
                    frmValor: [""],
                    frmaliquotaIPI: [""],
                })
            );
        });
    }

    exibirProdutos() {
        this.atualizarQuantidadeValorNosProdutos();
        this.atualizarIdSapProdutoNosProdutos();
        this.atualizarFormBuilderNosProdutos();

        this.atualizarPedidoProdutoEdicao();

        this.dataSourceProdutos = new MatTableDataSource<Produto>(
            this.protocolo.produtos
        );
        this.dataSourceProdutos.paginator = this.produtoPaginator;
        this.table.renderRows();
    }

    obterValorTotalParaSerRateado(): number {
        let valorTotalComDescontos =
            this.protocolo.valorTotalComDescontos || 0.0;
        let valorTotalRateiosArredondado =
            this.obterValorTotalRateiosComArredondamento();

        return this.correcaoValorNegativoRateio(
            valorTotalComDescontos,
            valorTotalRateiosArredondado
        );
    }

    correcaoValorNegativoRateio(
        valorTotalComDescontos,
        valorTotalRateiosArredondado
    ): number {
        if (valorTotalRateiosArredondado > valorTotalComDescontos) {
            return valorTotalRateiosArredondado - valorTotalComDescontos;
        }
        return valorTotalComDescontos - valorTotalRateiosArredondado;
    }

    atualizarPedidoProdutoEdicao() {
        if (
            this.tipoOperacao == TipoOperacao.Edicao &&
            this.protocolo.pedidos.length === 1
        ) {
            this.protocolo.produtos = this.protocolo.produtos.map(
                (p, index) => {
                    p.idSapPedidoContrato =
                        this.protocolo.pedidos[
                            index
                        ]?.codigoPedido.toString() || null;
                    return p;
                }
            );
        }
    }

    obterValorTotalParaSerMedido(): number {
        let valorTotalComDescontos =
            this.protocolo.valorTotalComDescontos || 0.0;
        let valorTotalMedicoes = this.selectionMedicao.selected.reduce(
            (sum, current) => sum + this.arredondar(current.valorTotal, 2),
            0.0
        );
        let valorTotalParaSerMedido =
            valorTotalComDescontos - valorTotalMedicoes;

        return valorTotalParaSerMedido;
    }

    obterValorTotalMedicoesComArredondamento(): number {
        let valorTotalMedicoes = this.selectionMedicao.selected.reduce(
            (sum, current) => sum + this.arredondar(current.valorTotal, 2),
            0.0
        );
        return valorTotalMedicoes;
    }

    atualizarValorTotalNosRateios(
        validarInconsistenciaCalculoValorRateio: boolean
    ) {
        if (this.protocolo.rateios && this.protocolo.rateios.length > 0) {
            this.protocolo.rateios.map((r) => {
                r =
                    this.atualizarQuantidadeDisponivelValorTotalComArredondamentoNoRateio(
                        r,
                        validarInconsistenciaCalculoValorRateio
                    );
            });
        }
    }

    atualizarQuantidadeDisponivelValorTotalComArredondamentoNoRateio(
        rateio: RateioDespesas,
        validarInconsistenciaCalculoValorRateio: boolean
    ): RateioDespesas {
        let produto = this.protocolo.produtos.find(
            (p) =>
                p.item === rateio.item.toString() &&
                p.idSapPedidoContrato === rateio.idSapPedidoContrato
        );
        if (produto) {
            let qtdOriginalProduto = produto.quantidadeOriginal;
            let qtdDisponivelProduto = produto.quantidade;
            let qtdOriginalRateio = rateio.quantidadeOriginal;
            let qtdDisponivelRateio =
                qtdOriginalProduto > 0
                    ? (qtdOriginalRateio * qtdDisponivelProduto) /
                      qtdOriginalProduto
                    : 0;

            qtdOriginalRateio = this.arredondar(qtdOriginalRateio, 4);
            qtdDisponivelRateio = this.arredondar(qtdDisponivelRateio, 4);

            rateio.quantidadeOriginal = qtdOriginalRateio;
            rateio.quantidade = qtdDisponivelRateio;

            let valorUnitarioProduto = produto.valorUnitario;
            let valorRateio = qtdDisponivelRateio * valorUnitarioProduto;
            let valorRateioArredondado = this.arredondar(valorRateio, 2);
            if (
                validarInconsistenciaCalculoValorRateio &&
                rateio.valor !== valorRateioArredondado
            ) {
                this.ExibeMensagem(
                    "Atenção",
                    `Existe uma inconsistência no cálculo do valor do rateio "${rateio.descricao}".`,
                    ""
                );
            } else {
                rateio.valor = valorRateioArredondado;
            }
        }

        return rateio;
    }

    obterProximoNumeroSerial(item: number): number {
        if (this.protocolo.rateios.length > 0) {
            if (item > 0) {
                let rateiosPorProduto = this.protocolo.rateios.filter(
                    (r) => r.item && Number(r.item) === item
                );
                let rateiosOrdenados = rateiosPorProduto.sort(function (a, b) {
                    return a.numeroSerial - b.numeroSerial;
                });
                let ultimoRateio = rateiosOrdenados.slice(-1)[0];
                if (ultimoRateio) {
                    let ultimoNumeroSerial = ultimoRateio.numeroSerial;
                    return ultimoNumeroSerial + 1;
                }
            } else {
                let rateiosPorProdutoOpcaoTodos = this.protocolo.rateios.filter(
                    (r) => !r.item
                );
                let rateiosOpcaoTodosOrdenados =
                    rateiosPorProdutoOpcaoTodos.sort(function (a, b) {
                        return a.numeroSerial - b.numeroSerial;
                    });
                let ultimoRateioOpcaoTodos =
                    rateiosOpcaoTodosOrdenados.slice(-1)[0];
                if (ultimoRateioOpcaoTodos) {
                    let ultimoNumeroSerialOpcaoTodos =
                        ultimoRateioOpcaoTodos.numeroSerial;
                    return ultimoNumeroSerialOpcaoTodos + 1;
                }
            }
        }

        return 1;
    }

    ordenarPedidos(pedidos: PedidoAssociado[]): PedidoAssociado[] {
        let pedidosOrdenados = pedidos.sort(function (a, b) {
            return (
                Number(a.idSapPedidoContrato) - Number(b.idSapPedidoContrato)
            );
        });

        return pedidosOrdenados;
    }

    ordenarProdutos(produtos: Produto[]): Produto[] {
        let produtosOrdenados = produtos.sort(function (a, b) {
            return (
                Number(a.idSapPedidoContrato) - Number(b.idSapPedidoContrato) ||
                Number(a.item) - Number(b.item)
            );
        });

        return produtosOrdenados;
    }

    ordenarRateios(rateios: RateioDespesas[]): RateioDespesas[] {
        let rateiosOrdenados = rateios.sort(function (a, b) {
            return (
                Number(a.idSapPedidoContrato) - Number(b.idSapPedidoContrato) ||
                a.item - b.item ||
                a.numeroSerial - b.numeroSerial
            );
        });

        return rateiosOrdenados;
    }

    ValidarSeValorTotalRateioUltrapassaValorTotalProdutoEmDezReaisOuMais(
        exibirMsgErro: boolean
    ): boolean {
        const valorTotalProdutosArredondado =
            this.obterValorTotalProdutosComArredondamento();
        const valorTotalRateiosArredondado =
            this.obterValorTotalRateiosComArredondamento();

        if (
            this.protocolo.produtos.length > 0 &&
            this.protocolo.rateios.length > 0 &&
            valorTotalRateiosArredondado - valorTotalProdutosArredondado >
                this.toleranciaDivergenciaRateio
        ) {
            this.bloquearBotaoSalvar = false;
            if (exibirMsgErro) {
                let msg = `O valor total do(s) rateio(s) \"R$ ${valorTotalRateiosArredondado}\" não pode(m) ultrapassar o limite de R$ 10,00 do valor total do(s) produto(s) \"R$ ${valorTotalProdutosArredondado}\".`;
                this.ExibeMensagem("ATENÇÃO", msg, "warning");
            }

            return false;
        }

        return true;
    }

    ValidarSeValorTotalProdutoUltrapassaValorTotalRateioEmDezReaisOuMais(
        exibirMsgErro: boolean
    ): boolean {
        const valorTotalProdutosArredondado =
            this.obterValorTotalProdutosComArredondamento();
        const valorTotalRateiosArredondado =
            this.obterValorTotalRateiosComArredondamento();

        if (
            this.protocolo.produtos.length > 0 &&
            this.protocolo.rateios.length > 0 &&
            valorTotalProdutosArredondado - valorTotalRateiosArredondado >
                this.toleranciaDivergenciaRateio
        ) {
            this.bloquearBotaoSalvar = false;
            if (exibirMsgErro) {
                let msg = `O valor total do(s) produto(s) \"R$ ${valorTotalProdutosArredondado}\" não pode(m) ultrapassar o limite de R$ 10,00 do valor total do(s) rateio(s) \"R$ ${valorTotalRateiosArredondado}\".`;
                this.ExibeMensagem("ATENÇÃO", msg, "warning");
            }

            return false;
        }

        return true;
    }

    ValidarSeValorTotalProtocoloUltrapassaValorTotalProduto(
        exibirMsgErro: boolean
    ): boolean {
        const valorTotalProdutosArredondado =
            this.obterValorTotalProdutosComArredondamento();

        if (
            this.protocolo.produtos.length > 0 &&
            this.converterValoresEmDuasCasasDecimais(
                this.protocolo.valorTotalComDescontos
            ) !== valorTotalProdutosArredondado
        ) {
            this.bloquearBotaoSalvar = false;
            if (exibirMsgErro) {
                let msg = `O valor total da nota fiscal \"R$ ${this.protocolo.valorTotalComDescontos}\" não pode ser diferente do valor total do(s) produto(s) \"R$ ${valorTotalProdutosArredondado}\".`;
                this.ExibeMensagem("ATENÇÃO", msg, "warning");
            }

            return false;
        }

        return true;
    }

    ValidarSeValorTotalProtocoloTemDiferenca10ReaisValorTotalProduto(
        exibirMsgErro: boolean
    ): boolean {
        const valorTotalProdutosArredondado =
            this.obterValorTotalProdutosComArredondamento();

        if (this.protocolo.produtos.length > 0) {
            if (
                this.converterValoresEmDuasCasasDecimais(
                    this.protocolo.valorTotalComDescontos
                ) -
                    valorTotalProdutosArredondado >
                10
            ) {
                this.bloquearBotaoSalvar = true;
                if (exibirMsgErro) {
                    let msg = `O valor total da nota fiscal "R$ ${this.protocolo.valorTotalComDescontos}" não pode ultrapassar o limite de R$ 10,00 do valor total do(s) produto(s) \"R$ ${valorTotalProdutosArredondado}\".`;
                    this.ExibeMensagem("ATENÇÃO", msg, "warning");
                }

                return false;
            }

            if (
                valorTotalProdutosArredondado -
                    this.converterValoresEmDuasCasasDecimais(
                        this.protocolo.valorTotalComDescontos
                    ) >
                10
            ) {
                this.bloquearBotaoSalvar = true;
                if (exibirMsgErro) {
                    let msg = `O valor total da nota fiscal \"R$ ${this.protocolo.valorTotalComDescontos}\" não pode ser menor que o limite de R$ 10,00 do valor total do(s) produto(s) \"R$ ${valorTotalProdutosArredondado}\".`;
                    this.ExibeMensagem("ATENÇÃO", msg, "warning");
                }

                return false;
            }
        }

        return true;
    }

    converterValoresEmDuasCasasDecimais(valor: number) {
        return parseFloat(valor.toFixed(2));
    }

    ValidarSeValorTotalProdutoUltrapassaValorTotalPedido(
        exibirMsgErro: boolean
    ): boolean {
        const valorTotalProdutosArredondado =
            this.obterValorTotalProdutosComArredondamento();
        const valorTotalPedidosArredondamento =
            this.obterValorTotalPedidosComArredondamento();

        if (
            this.protocolo.produtos.length > 0 &&
            this.protocolo.pedidos.length > 0 &&
            valorTotalProdutosArredondado > valorTotalPedidosArredondamento
        ) {
            this.bloquearBotaoSalvar = false;
            if (exibirMsgErro) {
                let msg = `O valor total do(s) produto(s) \"R$ ${valorTotalProdutosArredondado}\" não pode(m) ultrapassar o valor total do(s) pedido(s) \"R$ ${valorTotalPedidosArredondamento}\".`;
                this.ExibeMensagem("ATENÇÃO", msg, "warning");
            }

            return false;
        }

        return true;
    }

    ValidarSeUsuarioPossuiAcessoParaModificacaoProtocoloTerceiro(
        exibirMsgErro: boolean
    ): boolean {
        if (
            this.protocolo.modoEdicao &&
            this.currentUser.login !== this.protocolo.loginResponsavel &&
            !this.currentUser.movimentarProtocoloTerceiros
        ) {
            this.bloquearBotaoSalvar = false;
            if (exibirMsgErro) {
                this.ExibeMensagem(
                    "Atenção",
                    "Seu usuário não possui acesso para modificação de protocolos de terceiros",
                    ""
                );
            }

            return false;
        }

        return true;
    }

    ValidarSeAlgumProdutoEstaComValorSuperiorQuantidadeMaximaPermitida(
        exibirMsgErro: boolean
    ): boolean {
        let ehValido = true;
        if (this.pedidoPreexistente) {
            this.protocolo.produtos.forEach((p) => {
                if (p.quantidade > p.quantidadeMaxima) {
                    this.bloquearBotaoSalvar = false;
                    if (exibirMsgErro) {
                        let msg = `Para o Produto \"R$ ${p.descricao}\" a quantidade máxima permitida é \"R$ ${p.quantidadeMaxima}\".`;
                        this.ExibeMensagem("ATENÇÃO", msg, "warning");
                    }
                    ehValido = false;
                }
            });
        }

        return ehValido;
    }

    ValidaDescricaoRateio(rateios: RateioDespesas[]): RateioDespesas[] {
        rateios.forEach((rateio) => {
            if (!rateio.descricao || rateio.descricao === "") {
                rateio.descricao =
                    rateio.identificacaoColetor + " - " + rateio.valor;
            }
        });

        return rateios;
    }

    ehFabricaDeKits() {
        return this.empresaMrv?.codigoEmp == "FKIT";
    }
}

